export const adamLogoVertices = [
  -0.994314432144165, -0.0982490256428719, -0.5462645888328552,
  -0.9951103329658508, -0.0903891026973724, -0.4676653742790222,
  -0.9957217574119568, -0.082529179751873, -0.4519455134868622,
  -0.9962173700332642, -0.0746692642569542, -0.3733462989330292,
  -0.9966764450073242, -0.0668093413114548, -0.2004280090332031,
  -0.9968355298042297, -0.0589494146406651, -0.0510894954204559,
  -0.9970012903213501, -0.0510894954204559, 0.0982490256428719,
  -0.9973462224006653, -0.0432295724749565, 0.2318677008152008,
  -0.9974057078361511, -0.0353696495294571, 0.381206214427948,
  -0.996938169002533, -0.0275097284466028, 0.5148249268531799,
  -0.9970828294754028, -0.0196498055011034, 0.6405836343765259,
  -0.9973651170730591, -0.0039299610070884, -0.6563035249710083,
  -0.9975614547729492, 0.0039299610070884, -0.5226848125457764,
  -0.9973294734954834, 0.0117898834869266, -0.3890661597251892,
  -0.9973641037940979, 0.0196498055011034, -0.2554474771022797,
  -0.997250497341156, 0.0275097284466028, -0.1218287944793701,
  -0.9970781207084656, 0.0353696495294571, 0.0196498055011034,
  -0.9969462156295776, 0.0432295724749565, 0.1611284017562866,
  -0.9965370297431946, 0.0510894954204559, 0.318326860666275,
  -0.9953996539115906, 0.0589494146406651, 0.4991050660610199,
  -0.9942801594734192, 0.0721487477421761, -0.6012840270996094,
  -0.9942801594734192, 0.081679455935955, -0.0196498055011034,
  -0.9865832328796387, -0.1532684862613678, 0.216147854924202,
  -0.986420214176178, -0.1527081578969955, 0.1532684862613678,
  -0.9892821311950684, -0.137548640370369, 0.302606999874115,
  -0.9903201460838318, -0.1296887099742889, 0.3654863834381104,
  -0.9902242422103882, -0.1218287944793701, 0.4912451505661011,
  -0.9911900758743286, -0.1139688715338707, 0.5934241414070129,
  -0.986420214176178, -0.1061089485883713, 0.6997947692871094,
  -0.986420214176178, -0.0668093413114548, -0.7478734254837036,
  -0.9938539266586304, 0.0589494146406651, 0.6641634106636047,
  -0.9939626455307007, 0.082529179751873, -0.1296887099742889,
  -0.9932350516319275, 0.0903891026973724, 0.0903891026973724,
  -0.9924015998840332, 0.0982490256428719, 0.2004280090332031,
  -0.9906986951828003, 0.1061089485883713, 0.318326860666275,
  -0.9887104034423828, 0.1139688715338707, 0.4598054587841034,
  -0.9865846037864685, 0.1218287944793701, 0.6327237486839294,
  -0.986420214176178, 0.1327922195196152, -0.1296887099742889,
  -0.9785603284835815, -0.1936396360397339, -0.0746692642569542,
  -0.9785603284835815, -0.1918539553880692, 0.0039299610070884,
  -0.9818479418754578, -0.1768482476472855, -0.0432295724749565,
  -0.9831449389457703, -0.1689883321523666, 0.0668093413114548,
  -0.9850412607192993, -0.1611284017562866, 0.1689883321523666,
  -0.9860683083534241, -0.1454085558652878, 0.6248638033866882,
  -0.978962242603302, 0.0196498055011034, 0.7349027395248413,
  -0.9859368205070496, 0.1296887099742889, 0.4676653742790222,
  -0.9843779802322388, 0.137548640370369, 0.5619844198226929,
  -0.9813286662101746, 0.1454085558652878, 0.6641634106636047,
  -0.9787955284118652, 0.1611284017562866, -0.6327237486839294,
  -0.9785836935043335, 0.1689883321523666, -0.4126459062099457,
  -0.9785603284835815, 0.1708137094974518, 0.0668093413114548,
  -0.9712956547737122, -0.224007785320282, 0.0196498055011034,
  -0.9740760326385498, -0.216147854924202, -0.137548640370369,
  -0.9755304455757141, -0.2082879394292831, -0.0982490256428719,
  -0.9768211245536804, -0.2004280090332031, -0.0039299610070884,
  -0.9775540828704834, -0.1768482476472855, -0.6956031322479248,
  -0.9707003831863403, 0.0589494146406651, 0.7439201474189758,
  -0.9779911637306213, 0.1689883321523666, 0.5777042508125305,
  -0.9749165773391724, 0.1768482476472855, 0.6563035249710083,
  -0.9707003831863403, 0.1919042617082596, -0.6877431869506836,
  -0.9707003831863403, 0.2001808285713196, -0.5226848125457764,
  -0.9707003831863403, 0.2023568898439407, -0.1532684862613678,
  -0.9638902544975281, -0.2554474771022797, -0.0982490256428719,
  -0.9667179584503174, -0.2475875467061996, -0.3497665226459503,
  -0.9686466455459595, -0.2397276312112808, -0.302606999874115,
  -0.9705407023429871, -0.2318677008152008, -0.2082879394292831,
  -0.9680364727973938, -0.2082879394292831, 0.6956031322479248,
  -0.9628404378890991, 0.0903891026973724, -0.7911577224731445,
  -0.9678440093994141, 0.2082879394292831, -0.6091439723968506,
  -0.9666446447372437, 0.216147854924202, -0.5148249268531799,
  -0.9647189974784851, 0.224007785320282, -0.396926075220108,
  -0.9628404378890991, 0.2310496419668198, -0.216147854924202,
  -0.9549805521965027, -0.2870444655418396, -0.1139688715338707,
  -0.9549805521965027, -0.2853235304355621, 0.0903891026973724,
  -0.959040105342865, -0.2711673080921173, 0.0903891026973724,
  -0.9615817666053772, -0.2633073925971985, 0.1454085558652878,
  -0.9562615156173706, -0.216147854924202, 0.7270427942276001,
  -0.9557093977928162, 0.137548640370369, 0.750622570514679,
  -0.9625643491744995, 0.2318677008152008, 0.0353696495294571,
  -0.9601412415504456, 0.2397276312112808, 0.1139688715338707,
  -0.9579381346702576, 0.2475875467061996, 0.216147854924202,
  -0.9549805521965027, 0.2549432814121246, 0.3654863834381104,
  -0.9471206068992615, -0.3144604563713074, -0.2947470843791962,
  -0.9483411312103271, -0.302606999874115, -0.5777042508125305,
  -0.95015949010849, -0.2947470843791962, -0.6170039176940918,
  -0.954217791557312, -0.2868871688842773, -0.5462645888328552,
  -0.9539591670036316, -0.224007785320282, -0.7742023468017578,
  -0.9471206068992615, 0.1611284017562866, -0.7973576784133911,
  -0.9526073932647705, 0.2633073925971985, -0.4912451505661011,
  -0.94992595911026, 0.2711673080921173, -0.3890661597251892,
  -0.9471912980079651, 0.2790272235870361, -0.2633073925971985,
  -0.939260721206665, -0.3376678824424744, -0.3419066071510315,
  -0.9394293427467346, -0.3261867761611938, -0.6012840270996094,
  -0.939260721206665, -0.3252164423465729, -0.6170039176940918,
  -0.9457903504371643, -0.3104669153690338, -0.5698443651199341,
  -0.939260721206665, -0.1824265122413635, 0.7584825158119202,
  -0.9460017681121826, 0.2318677008152008, 0.7349027395248413,
  -0.9418385624885559, 0.2790272235870361, 0.7034630179405212,
  -0.939260721206665, 0.2941089272499084, -0.6641634106636047,
  -0.939260721206665, 0.3001424968242645, -0.475525289773941,
  -0.9314007759094238, -0.3607918620109558, -0.2004280090332031,
  -0.9346453547477722, -0.3497665226459503, -0.381206214427948,
  -0.9378325343132019, -0.3419066071510315, -0.1847081780433655,
  -0.9314007759094238, -0.3296441435813904, -0.7191829085350037,
  -0.9314007759094238, -0.1139688715338707, 0.7725206613540649,
  -0.9375799298286438, 0.2790272235870361, 0.7191829085350037,
  -0.9375525116920471, 0.302606999874115, 0.4676653742790222,
  -0.9340153336524963, 0.3104669153690338, 0.5619844198226929,
  -0.9314007759094238, 0.3184268772602081, -0.5698443651199341,
  -0.9236198663711548, -0.381206214427948, -0.0432295724749565,
  -0.9266964793205261, -0.3733462989330292, 0.224007785320282,
  -0.9282792210578918, -0.3654863834381104, 0.4126459062099457,
  -0.9235408306121826, -0.3429124355316162, 0.7034630179405212,
  -0.926152229309082, -0.0196498055011034, 0.7820622324943542,
  -0.9254813194274902, 0.318326860666275, -0.7270427942276001,
  -0.9287590980529785, 0.3261867761611938, 0.3419066071510315,
  -0.9248169660568237, 0.3340466916561127, 0.4676653742790222,
  -0.9156809449195862, -0.39753657579422, -0.4598054587841034,
  -0.9174615740776062, -0.396926075220108, 0.318326860666275,
  -0.9164771437644958, -0.3890661597251892, 0.5148249268531799,
  -0.9156809449195862, -0.3721851706504822, -0.7034630179405212,
  -0.9188570976257324, -0.1061089485883713, 0.7820622324943542,
  -0.919417679309845, 0.318326860666275, 0.7270427942276001,
  -0.9217379689216614, 0.3419066071510315, 0.4519455134868622,
  -0.917551577091217, 0.3497665226459503, 0.5619844198226929,
  -0.907820999622345, -0.4205735921859741, -0.318326860666275,
  -0.907820999622345, -0.4182632565498352, -0.4047859907150269,
  -0.9147257804870605, -0.4047859907150269, -0.2790272235870361,
  -0.907820999622345, -0.3939590454101563, -0.6877431869506836,
  -0.907820999622345, -0.1847081780433655, 0.7802301645278931,
  -0.907820999622345, 0.2643558382987976, -0.8056420087814331,
  -0.9150417447090149, 0.3576264679431915, 0.1454085558652878,
  -0.9120876789093018, 0.3654863834381104, 0.2711673080921173,
  -0.908190131187439, 0.3733462989330292, 0.3261867761611938,
  -0.8999611139297485, -0.4413987994194031, -0.0903891026973724,
  -0.9053149819374084, -0.4283657670021057, -0.1689883321523666,
  -0.8999611139297485, -0.4126459062099457, -0.684872567653656,
  -0.8999611139297485, -0.2947470843791962, -0.8067201972007751,
  -0.9051657915115356, 0.137548640370369, -0.829221785068512,
  -0.9077445268630981, 0.3733462989330292, -0.3497665226459503,
  -0.9046010375022888, 0.381206214427948, 0.2868871688842773,
  -0.8999611139297485, 0.3878789246082306, 0.4440855979919434,
  -0.8921011686325073, -0.4580317139625549, -0.2397276312112808,
  -0.8957074284553528, -0.4440855979919434, -0.4676653742790222,
  -0.895369827747345, -0.4362256824970245, 0.5462645888328552,
  -0.8921011686325073, -0.3177528381347656, -0.8056420087814331,
  -0.8938090205192566, 0.1847081780433655, -0.829221785068512,
  -0.8986514806747437, 0.3890661597251892, 0.4991050660610199,
  -0.892842173576355, 0.396926075220108, 0.6091439723968506,
  -0.8921011686325073, 0.4048253297805786, 0.0353696495294571,
  -0.8842412233352661, -0.4736872613430023, -0.3261867761611938,
  -0.891559362411499, -0.4598054587841034, -0.2004280090332031,
  -0.8877891302108765, -0.4440855979919434, 0.6170039176940918,
  -0.8907341361045837, -0.2082879394292831, -0.829221785068512,
  -0.8842412233352661, 0.2318677008152008, 0.783926248550415,
  -0.8920381665229797, 0.4047859907150269, -0.1061089485883713,
  -0.8878840804100037, 0.4126459062099457, 0.2868871688842773,
  -0.8842412233352661, 0.4133934676647186, 0.5462645888328552,
  -0.8793225288391113, -0.4833852052688599, -0.3497665226459503,
  -0.883051872253418, -0.475525289773941, 0.3497665226459503,
  -0.8833122849464417, -0.4362256824970245, 0.7034630179405212,
  -0.8783177733421326, -0.0275097284466028, -0.8528015613555908,
  -0.8763813376426697, 0.3830023407936096, 0.7427626252174377,
  -0.8833507299423218, 0.4205058217048645, 0.3104669153690338,
  -0.8768556118011475, 0.4283657670021057, 0.475525289773941,
  -0.8685213923454285, -0.5098004937171936, -0.1532684862613678,
  -0.8740653395652771, -0.4991050660610199, -0.0903891026973724,
  -0.8746871948242188, -0.4833852052688599, -0.5541245341300964,
  -0.8685213923454285, -0.3654863834381104, -0.8079644441604614,
  -0.8686805963516235, 0.0982490256428719, 0.8135019540786743,
  -0.8745877742767334, 0.4283657670021057, -0.6012840270996094,
  -0.870455801486969, 0.4362256824970245, 0.5462645888328552,
  -0.8685213923454285, 0.4462218582630157, -0.381206214427948,
  -0.860661506652832, -0.5260894298553467, 0.082529179751873,
  -0.860661506652832, -0.5199440121650696, 0.3654863834381104,
  -0.8612343072891235, -0.4912451505661011, 0.6484435796737671,
  -0.860661506652832, -0.2082879394292831, -0.8451775908470154,
  -0.860661506652832, 0.240661546587944, -0.8370817303657532,
  -0.8636468648910522, 0.4440855979919434, 0.6563035249710083,
  -0.860661506652832, 0.4576415121555328, -0.4440855979919434,
  -0.854291558265686, -0.538404643535614, 0.0117898834869266,
  -0.8528015613555908, -0.5370422005653381, 0.3261867761611938,
  -0.8528015613555908, -0.509431779384613, 0.6091439723968506,
  -0.8597843050956726, -0.2554474771022797, 0.7977821230888367,
  -0.8546614646911621, 0.2554474771022797, -0.8370817303657532,
  -0.8570623993873596, 0.4598054587841034, -0.5148249268531799,
  -0.8555234670639038, 0.4676653742790222, -0.2868871688842773,
  -0.8528015613555908, 0.4707271456718445, 0.1532684862613678,
  -0.8449416160583496, -0.55268794298172, -0.2868871688842773,
  -0.8449416160583496, -0.5315262079238892, -0.5934241414070129,
  -0.8449416160583496, -0.475525289773941, -0.7845944762229919,
  -0.8469524383544922, -0.0510894954204559, 0.829221785068512,
  -0.8449416160583496, 0.38919398188591, -0.8056420087814331,
  -0.8501594066619873, 0.475525289773941, -0.2554474771022797,
  -0.8449416160583496, 0.4826040863990784, 0.082529179751873,
  -0.8412090539932251, -0.5619844198226929, 0.0982490256428719,
  -0.8409611582756042, -0.5462645888328552, 0.4676653742790222,
  -0.8392875194549561, -0.4598054587841034, -0.7977821230888367,
  -0.8370817303657532, 0.0117898834869266, 0.8349117636680603,
  -0.8370817303657532, 0.4512857794761658, -0.7742023468017578,
  -0.8442182540893555, 0.4833852052688599, 0.1454085558652878,
  -0.8370817303657532, 0.4911946356296539, 0.4047859907150269,
  -0.8327003717422485, -0.5777042508125305, -0.0903891026973724,
  -0.8362377882003784, -0.5698443651199341, 0.2318677008152008,
  -0.8365244269371033, -0.538404643535614, 0.5934241414070129,
  -0.829221785068512, -0.2397276312112808, 0.8159886598587036,
  -0.829221785068512, 0.224007785320282, 0.8154164552688599,
  -0.8324981927871704, 0.4912451505661011, -0.5619844198226929,
  -0.829221785068512, 0.497913271188736, 0.5148249268531799,
  -0.8213618397712708, -0.5970472693443298, -0.0510894954204559,
  -0.826333224773407, -0.5855641961097717, 0.2868871688842773,
  -0.8288405537605286, -0.5541245341300964, -0.6170039176940918,
  -0.822058379650116, -0.2790272235870361, 0.8135019540786743,
  -0.8220792412757874, 0.216147854924202, -0.860661506652832,
  -0.8261098265647888, 0.4991050660610199, -0.5698443651199341,
  -0.8213618397712708, 0.5030651092529297, 0.6012840270996094,
  -0.8213618397712708, 0.5154144763946533, 0.0982490256428719,
  -0.8135019540786743, -0.607658326625824, 0.216147854924202,
  -0.8141999840736389, -0.5777042508125305, 0.5698443651199341,
  -0.8135019540786743, -0.381206214427948, -0.833421528339386,
  -0.8135019540786743, 0.0982490256428719, -0.8833281397819519,
  -0.8176896572113037, 0.4991050660610199, -0.7034630179405212,
  -0.8148655295372009, 0.5226848125457764, -0.3576264679431915,
  -0.8135019540786743, 0.5257132649421692, 0.1689883321523666,
  -0.8056420087814331, -0.6127881407737732, -0.3733462989330292,
  -0.8056420087814331, -0.5906804800033569, -0.5934241414070129,
  -0.8056420087814331, -0.396926075220108, 0.7943698763847351,
  -0.8056420087814331, 0.1151992604136467, -0.8842412233352661,
  -0.8127066493034363, 0.5069649815559387, -0.6877431869506836,
  -0.8096699118614197, 0.5305447578430176, 0.0432295724749565,
  -0.79837566614151, -0.6327237486839294, -0.1454085558652878,
  -0.7977821230888367, -0.630859375, 0.2633073925971985, -0.7977821230888367,
  -0.5971582531929016, 0.5934241414070129, -0.7977821230888367,
  -0.3419066071510315, -0.8497021198272705, -0.7977821230888367,
  0.216147854924202, -0.8719273805618286, -0.8003789186477661,
  0.5226848125457764, 0.6563035249710083, -0.7996166944503784,
  0.538404643535614, 0.4126459062099457, -0.7899221777915955,
  -0.6465048789978027, -0.0903891026973724, -0.7899221777915955,
  -0.6288527250289917, -0.4676653742790222, -0.7899221777915955,
  -0.5845879316329956, 0.6956031322479248, -0.7899221777915955,
  -0.1689883321523666, -0.8855976462364197, -0.7899221777915955,
  0.4047859907150269, 0.7862006425857544, -0.7944508790969849,
  0.5462645888328552, -0.4047859907150269, -0.7899757623672485,
  0.5541245341300964, 0.0196498055011034, -0.7832695245742798,
  -0.6484435796737671, -0.3261867761611938, -0.7871439456939697,
  -0.6327237486839294, -0.4676653742790222, -0.7820622324943542,
  -0.5683985352516174, 0.7427626252174377, -0.7820622324943542,
  -0.0903891026973724, -0.8886880874633789, -0.7820622324943542,
  0.4362256824970245, 0.7801558971405029, -0.7887548208236694,
  0.5541245341300964, -0.2790272235870361, -0.7820622324943542,
  0.5605372190475464, 0.3654863834381104, -0.776712954044342,
  -0.6641634106636047, 0.1689883321523666, -0.775111198425293,
  -0.6327237486839294, -0.5855641961097717, -0.7742023468017578,
  -0.4967266023159027, 0.7820622324943542, -0.7798697948455811,
  -0.0039299610070884, -0.8842412233352661, -0.7783060073852539,
  0.475525289773941, -0.8056420087814331, -0.7800467610359192,
  0.5619844198226929, 0.3890661597251892, -0.7742023468017578,
  0.5713353753089905, -0.0432295724749565, -0.7720237970352173,
  -0.6720233559608459, 0.1061089485883713, -0.7710772752761841,
  -0.6405836343765259, -0.5698443651199341, -0.7663424015045166,
  -0.4567200541496277, -0.8370817303657532, -0.7663424015045166,
  0.0275097284466028, -0.8752706050872803, -0.7663424015045166,
  0.4912451505661011, 0.7678618431091309, -0.7663424015045166,
  0.5638863444328308, 0.5855641961097717, -0.7663424015045166,
  0.5802417993545532, 0.1139688715338707, -0.7657169103622437,
  -0.6798832416534424, 0.1454085558652878, -0.7584825158119202,
  -0.6467128992080688, -0.6170039176940918, -0.7597581744194031,
  -0.3733462989330292, -0.860661506652832, -0.7584825158119202,
  0.1296887099742889, 0.8416264653205872, -0.7622767090797424,
  0.5541245341300964, 0.7034630179405212, -0.7607970833778381,
  0.5855641961097717, -0.0982490256428719, -0.750622570514679,
  -0.6997620463371277, -0.2318677008152008, -0.750622570514679,
  -0.6843687891960144, -0.4283657670021057, -0.750622570514679,
  -0.6269078850746155, 0.7034630179405212, -0.7548139095306396,
  -0.1925680935382843, 0.8449416160583496, -0.750622570514679,
  0.2633073925971985, -0.8836431503295898, -0.750622570514679,
  0.5722962617874146, -0.6641634106636047, -0.7528101205825806,
  0.5934241414070129, 0.2397276312112808, -0.7427626252174377,
  -0.7119385600090027, 0.0668093413114548, -0.7498211264610291,
  -0.6877431869506836, 0.3654863834381104, -0.7490925192832947,
  -0.6091439723968506, -0.7820622324943542, -0.7453704476356506,
  -0.1611284017562866, -0.8763813376426697, -0.7440021634101868,
  0.3419066071510315, 0.829221785068512, -0.7462084293365479,
  0.5855641961097717, 0.5541245341300964, -0.7427626252174377,
  0.5986325740814209, 0.4205058217048645, -0.7352707982063293,
  -0.7191829085350037, 0.1454085558652878, -0.7349027395248413,
  -0.680830717086792, -0.5777042508125305, -0.7349027395248413,
  -0.5069649815559387, -0.8350100517272949, -0.739250123500824,
  -0.0432295724749565, -0.860661506652832, -0.7349027395248413,
  0.4257304668426514, 0.8056420087814331, -0.7394893765449524,
  0.6012840270996094, -0.4519455134868622, -0.7349027395248413, 0.6107137799263,
  -0.137548640370369, -0.732134222984314, -0.7191829085350037,
  -0.302606999874115, -0.7300609350204468, -0.6720233559608459,
  -0.6405836343765259, -0.7270427942276001, -0.3890661597251892,
  -0.8720115423202515, -0.7270427942276001, 0.0982490256428719,
  -0.8581111431121826, -0.7270427942276001, 0.5541245341300964,
  -0.7912847399711609, -0.7270427942276001, 0.6115915775299072,
  -0.4598054587841034, -0.7191829085350037, -0.743029773235321,
  -0.0746692642569542, -0.7240240573883057, -0.7191829085350037,
  -0.396926075220108, -0.7191829085350037, -0.6567012071609497,
  0.7113229632377625, -0.7191829085350037, -0.2318677008152008,
  -0.8729420304298401, -0.7191829085350037, 0.224007785320282,
  0.8353517055511475, -0.7191829085350037, 0.5979645252227783,
  -0.6798832416534424, -0.7192501425743103, 0.6248638033866882,
  -0.1218287944793701, -0.7113229632377625, -0.7501168251037598,
  -0.1768482476472855, -0.7182835340499878, -0.7113229632377625,
  -0.4991050660610199, -0.718455970287323, -0.5462645888328552,
  0.7899221777915955, -0.7113229632377625, -0.0903891026973724,
  0.8039207458496094, -0.7113229632377625, 0.3576264679431915,
  0.8403034806251526, -0.7113229632377625, 0.6156090497970581,
  -0.5855641961097717, -0.7113229632377625, 0.6317893266677856,
  0.0432295724749565, -0.7053819298744202, -0.750622570514679,
  0.224007785320282, -0.7034630179405212, -0.6956031322479248,
  0.6158888936042786, -0.7034630179405212, -0.3890661597251892,
  -0.8823981285095215, -0.7034630179405212, 0.082529179751873,
  0.8018004298210144, -0.7034630179405212, 0.5462645888328552,
  0.772624135017395, -0.7082344889640808, 0.6327237486839294,
  -0.2633073925971985, -0.7034630179405212, 0.63390052318573,
  0.3733462989330292, -0.6956532597541809, -0.750622570514679,
  0.3419066071510315, -0.6981124877929688, -0.6720233559608459,
  -0.7584825158119202, -0.7011671662330627, -0.2633073925971985,
  -0.8685213923454285, -0.6956031322479248, 0.1768482476472855,
  0.8124046921730042, -0.6956031322479248, 0.6073890924453735,
  -0.750622570514679, -0.7005224227905273, 0.6405836343765259,
  -0.0510894954204559, -0.6915962100028992, -0.7742023468017578,
  -0.0510894954204559, -0.69548499584198, -0.7427626252174377,
  -0.4362256824970245, -0.6877431869506836, -0.6248638033866882,
  0.7706917524337769, -0.6938677430152893, -0.1611284017562866,
  -0.8449416160583496, -0.6877431869506836, 0.2671127319335938,
  0.829221785068512, -0.6938303112983704, 0.6248638033866882,
  0.6012840270996094, -0.6903025507926941, 0.6484435796737671,
  0.1296887099742889, -0.6813638806343079, -0.7820622324943542,
  0.1296887099742889, -0.6844407320022583, -0.7349027395248413,
  0.5069649815559387, -0.6798832416534424, -0.5148249268531799,
  0.8160216212272644, -0.6798832416534424, -0.0668093413114548,
  0.7824022769927979, -0.6798832416534424, 0.396926075220108,
  0.8403389453887939, -0.683230459690094, 0.6405836343765259,
  0.5226848125457764, -0.6798832416534424, 0.6509385704994202,
  0.396926075220108, -0.6763674020767212, -0.7663424015045166,
  -0.396926075220108, -0.6768164038658142, -0.6877431869506836,
  0.7270427942276001, -0.6720233559608459, -0.2554474771022797,
  -0.849739134311676, -0.6720233559608459, 0.1847081780433655,
  -0.8430952429771423, -0.6720233559608459, 0.6174620389938354,
  -0.7742023468017578, -0.6794424653053284, 0.6563035249710083,
  0.0432295724749565, -0.6641634106636047, -0.8024323582649231,
  -0.0353696495294571, -0.6641634106636047, -0.7599329948425293,
  -0.5069649815559387, -0.6641634106636047, -0.6182954907417297,
  0.7820622324943542, -0.6641634106636047, -0.1611284017562866,
  0.7834351062774658, -0.6641634106636047, 0.2554474771022797,
  -0.8569434881210327, -0.6641634106636047, 0.6405836343765259,
  -0.6887962818145752, -0.6687130928039551, 0.6641634106636047,
  0.1532684862613678, -0.6586078405380249, -0.8056420087814331,
  0.1139688715338707, -0.6566933393478394, -0.750622570514679,
  -0.5855641961097717, -0.6578532457351685, -0.5226848125457764,
  -0.860661506652832, -0.6563035249710083, -0.082529179751873,
  0.7663601636886597, -0.6563035249710083, 0.3419066071510315,
  -0.8826992511749268, -0.6563035249710083, 0.6563035249710083,
  -0.5880288481712341, -0.6563035249710083, 0.6703880429267883,
  0.318326860666275, -0.6515353322029114, -0.7977821230888367,
  -0.318326860666275, -0.6490209102630615, -0.7349027395248413,
  0.6405836343765259, -0.6525694131851196, -0.381206214427948,
  0.8370817303657532, -0.6561684608459473, 0.0432295724749565,
  0.7663424015045166, -0.6484435796737671, 0.4779894351959229,
  0.8213618397712708, -0.6484435796737671, 0.6671660542488098,
  -0.5069649815559387, -0.6405836343765259, -0.8226737380027771,
  -0.1061089485883713, -0.6449569463729858, -0.7899221777915955,
  0.3890661597251892, -0.6405836343765259, -0.6563035249710083,
  -0.8164828419685364, -0.6405836343765259, -0.2082879394292831,
  0.7780113816261292, -0.6446031332015991, 0.224007785320282,
  -0.8370817303657532, -0.6405836343765259, 0.6427098512649536,
  -0.7663424015045166, -0.6449728608131409, 0.6798832416534424,
  0.0039299610070884, -0.6327237486839294, -0.8222681283950806,
  -0.2318677008152008, -0.6391106247901917, -0.7742023468017578,
  -0.538404643535614, -0.6327237486839294, -0.5541245341300964,
  0.8195436596870422, -0.6350879073143005, -0.1139688715338707,
  -0.7977821230888367, -0.6327237486839294, 0.2728529572486877,
  -0.8449416160583496, -0.6327237486839294, 0.65581214427948,
  0.6956031322479248, -0.6327237486839294, 0.6874475479125977,
  0.0039299610070884, -0.6300754547119141, -0.8135019540786743,
  -0.3340466916561127, -0.6314748525619507, -0.7349027395248413,
  0.6877431869506836, -0.6248638033866882, -0.3402785360813141,
  0.8056420087814331, -0.6277188658714294, -0.0196498055011034,
  0.7270427942276001, -0.6248638033866882, 0.2711673080921173,
  0.7983235716819763, -0.6248638033866882, 0.6564999222755432,
  -0.750622570514679, -0.6312841773033142, 0.6877431869506836,
  0.224007785320282, -0.6170039176940918, -0.8408440947532654,
  0.1218287944793701, -0.6170039176940918, -0.7751014828681946,
  -0.6091439723968506, -0.6170039176940918, -0.5031804442405701,
  -0.8842412233352661, -0.618529200553894, -0.0982490256428719,
  0.7270427942276001, -0.6170039176940918, 0.0039299610070884,
  -0.7061117887496948, -0.6248005628585815, 0.1925680935382843,
  0.7742023468017578, -0.6176537275314331, 0.6248638033866882,
  0.7663424015045166, -0.6170039176940918, 0.6952551603317261,
  -0.216147854924202, -0.6091439723968506, -0.8493915200233459,
  0.0432295724749565, -0.6132740378379822, -0.7899221777915955,
  -0.5541245341300964, -0.6114072799682617, -0.5462645888328552,
  -0.8685213923454285, -0.6091439723968506, -0.1326278448104858,
  -0.7742023468017578, -0.6168285012245178, -0.0353696495294571,
  0.6563035249710083, -0.6130315065383911, 0.082529179751873,
  -0.7584825158119202, -0.6091439723968506, 0.4283657670021057,
  -0.8855674862861633, -0.6165200471878052, 0.6877431869506836,
  -0.4833852052688599, -0.6091439723968506, 0.6963613033294678,
  0.3654863834381104, -0.6012840270996094, -0.8219172954559326,
  0.396926075220108, -0.6012840270996094, -0.6798832416534424,
  0.7771183848381042, -0.6012840270996094, -0.2318677008152008,
  -0.8034679293632507, -0.6012840270996094, -0.082529179751873,
  -0.6534733772277832, -0.6040640473365784, 0.0275097284466028,
  0.6012840270996094, -0.6081783175468445, 0.1454085558652878,
  0.750622570514679, -0.6012840270996094, 0.5712351202964783,
  0.7977821230888367, -0.6012840270996094, 0.7002701759338379,
  -0.3733462989330292, -0.5934241414070129, -0.8616976141929626,
  0.0117898834869266, -0.5959017276763916, -0.8135019540786743,
  0.4676653742790222, -0.5934241414070129, -0.6170039176940918,
  0.8064642548561096, -0.5934241414070129, -0.1847081780433655,
  -0.780744731426239, -0.5962910056114197, -0.0903891026973724,
  -0.6327237486839294, -0.5971985459327698, -0.0039299610070884,
  0.538404643535614, -0.5934241414070129, 0.0982490256428719,
  0.6311017870903015, -0.5934241414070129, 0.3576264679431915,
  -0.8562163114547729, -0.5934241414070129, 0.6877431869506836,
  0.5990457534790039, -0.5934241414070129, 0.7084181904792786,
  0.2004280090332031, -0.5894718766212463, -0.829221785068512,
  -0.4362256824970245, -0.5855641961097717, -0.6956031322479248,
  -0.8173384070396423, -0.5855641961097717, -0.2558871507644653,
  0.7584825158119202, -0.5929902195930481, -0.1296887099742889,
  0.6091439723968506, -0.5865926146507263, -0.0510894954204559,
  0.4676653742790222, -0.5918089747428894, 0.0353696495294571,
  -0.5934241414070129, -0.5855641961097717, 0.1218287944793701,
  0.63469398021698, -0.5869684219360352, 0.4047859907150269, 0.8370817303657532,
  -0.5855641961097717, 0.6912315487861633, 0.6012840270996094,
  -0.5855641961097717, 0.7130215764045715, -0.082529179751873,
  -0.5777042508125305, -0.8491339087486267, -0.3576264679431915,
  -0.5812875628471375, -0.750622570514679, -0.7742023468017578,
  -0.583683967590332, -0.3340466916561127, 0.7820622324943542,
  -0.5841246247291565, -0.1611284017562866, 0.6170039176940918,
  -0.5777042508125305, -0.0955977290868759, -0.4676653742790222,
  -0.5824673175811768, -0.0510894954204559, 0.4205058217048645,
  -0.5780454277992249, -0.0117898834869266, 0.2868871688842773,
  -0.5786572694778442, 0.0353696495294571, -0.4833852052688599,
  -0.5777042508125305, 0.1061089485883713, 0.5554929375648499,
  -0.5777042508125305, 0.2790272235870361, 0.7789087295532227,
  -0.5801899433135986, 0.6798832416534424, 0.7113229632377625,
  -0.5777042508125305, 0.7167794108390808, -0.137548640370369,
  -0.5698443651199341, -0.860661506652832, 0.270672470331192,
  -0.5698443651199341, -0.7712063789367676, -0.7349027395248413,
  -0.5698443651199341, -0.3733462989330292, 0.7896681427955627,
  -0.5755661129951477, -0.1768482476472855, -0.6641634106636047,
  -0.5706101655960083, -0.1218287944793701, 0.396926075220108,
  -0.5762782692909241, -0.0982490256428719, 0.4126459062099457,
  -0.5726134181022644, -0.082529179751873, -0.2004280090332031,
  -0.5749521255493164, -0.0668093413114548, -0.224007785320282,
  -0.5754868984222412, -0.0510894954204559, -0.0668093413114548,
  -0.5764951705932617, -0.0353696495294571, 0.2082879394292831,
  -0.5762937068939209, -0.0117898834869266, -0.1454085558652878,
  -0.5750710368156433, 0.0039299610070884, 0.0353696495294571,
  -0.5732197165489197, 0.0196498055011034, 0.0746692642569542,
  -0.5698464512825012, 0.0353696495294571, -0.0432295724749565,
  -0.5731773376464844, 0.0510894954204559, 0.3654863834381104,
  -0.5698443651199341, 0.1061089485883713, 0.5019569396972656,
  -0.5736275315284729, 0.2082879394292831, 0.750622570514679,
  -0.5698443651199341, 0.660628616809845, -0.7977821230888367,
  -0.5729304552078247, 0.7191829085350037, -0.0353696495294571,
  -0.5619844198226929, -0.8699176907539368, -0.2711673080921173,
  -0.5619844198226929, -0.8021222352981567, 0.6091439723968506,
  -0.5619844198226929, -0.4565965235233307, 0.8213618397712708,
  -0.5619844198226929, -0.211185097694397, 0.6012840270996094,
  -0.5653043985366821, -0.1532684862613678, 0.4440855979919434,
  -0.5648926496505737, -0.1296887099742889, 0.2947470843791962,
  -0.5655546188354492, -0.1139688715338707, -0.137548640370369,
  -0.569641649723053, 0.0353696495294571, -0.1532684862613678,
  -0.5643066763877869, 0.0589494146406651, -0.1847081780433655,
  -0.5619844198226929, 0.0700368508696556, -0.2711673080921173,
  -0.5661426782608032, 0.1061089485883713, -0.538404643535614,
  -0.5619844198226929, 0.1832792907953262, -0.7191829085350037,
  -0.5619844198226929, 0.538404643535614, -0.857741117477417,
  -0.5626526474952698, 0.7191829085350037, -0.4047859907150269,
  -0.5541245341300964, -0.8894339799880981, -0.0039299610070884,
  -0.5541245341300964, -0.8322272896766663, -0.5462645888328552,
  -0.5541245341300964, -0.5855641961097717, 0.833187997341156,
  -0.5542109608650208, -0.2397276312112808, 0.6484435796737671,
  -0.5608025193214417, -0.1768482476472855, -0.5305447578430176,
  -0.5550596714019775, -0.1532684862613678, -0.1925680935382843,
  -0.5608726143836975, -0.1454085558652878, 0.302606999874115,
  -0.5609492063522339, 0.0746692642569542, 0.1061089485883713,
  -0.561503529548645, 0.0903891026973724, 0.3419066071510315,
  -0.555358350276947, 0.1139688715338707, 0.396926075220108,
  -0.5541245341300964, 0.1873974204063416, -0.6956031322479248,
  -0.5541245341300964, 0.5226848125457764, 0.8345956206321716,
  -0.5541245341300964, 0.7149623036384583, 0.5069649815559387,
  -0.5462645888328552, -0.8944652676582336, -0.0039299610070884,
  -0.5462645888328552, -0.844407320022583, 0.475525289773941,
  -0.5462645888328552, -0.5973305106163025, -0.8685213923454285,
  -0.5507140755653381, -0.2554474771022797, 0.6798832416534424,
  -0.5501865744590759, -0.1925680935382843, -0.4833852052688599,
  -0.5488913059234619, -0.1768482476472855, 0.2633073925971985,
  -0.5516762733459473, -0.1611284017562866, 0.1061089485883713,
  -0.553886353969574, 0.1061089485883713, 0.2947470843791962,
  -0.5462645888328552, 0.1237597167491913, -0.396926075220108,
  -0.5462645888328552, 0.1925680935382843, 0.6193598508834839,
  -0.5462645888328552, 0.4912451505661011, 0.8493978381156921,
  -0.5462645888328552, 0.7126811742782593, 0.5619844198226929,
  -0.5431206226348877, -0.8921011686325073, -0.1532684862613678,
  -0.5422912836074829, -0.8449416160583496, 0.4833852052688599,
  -0.538404643535614, -0.6012840270996094, 0.8308916091918945,
  -0.5393642783164978, -0.2633073925971985, 0.6405836343765259,
  -0.5389567613601685, -0.2082879394292831, -0.4205058217048645,
  -0.538404643535614, -0.1947963833808899, -0.0039299610070884,
  -0.5453903675079346, 0.1139688715338707, -0.1689883321523666,
  -0.5405237674713135, 0.1296887099742889, 0.1925680935382843,
  -0.5444672107696533, 0.1611284017562866, -0.5698443651199341,
  -0.538404643535614, 0.2475875467061996, -0.7840659022331238,
  -0.538404643535614, 0.6641634106636047, -0.8072435259819031,
  -0.538404643535614, 0.7337918877601624, -0.1218287944793701,
  -0.5353852510452271, -0.8842412233352661, 0.2475875467061996,
  -0.5330403447151184, -0.7899221777915955, 0.7034630179405212,
  -0.5305447578430176, -0.3733462989330292, -0.8139193654060364,
  -0.5333985686302185, -0.2397276312112808, -0.5541245341300964,
  -0.5360115766525269, -0.216147854924202, 0.3576264679431915,
  -0.536102831363678, -0.2004280090332031, 0.0668093413114548,
  -0.532052218914032, 0.1454085558652878, 0.1689883321523666,
  -0.5305447578430176, 0.1768482476472855, -0.5363379120826721,
  -0.5305447578430176, 0.2868871688842773, -0.8019201755523682,
  -0.5368369817733765, 0.7034630179405212, 0.6720233559608459,
  -0.5305447578430176, 0.7345204949378967, 0.2790272235870361,
  -0.5226848125457764, -0.8958568572998047, 0.2082879394292831,
  -0.5226848125457764, -0.7977821230888367, -0.7310610413551331,
  -0.5255547165870667, -0.4047859907150269, 0.7820622324943542,
  -0.5226848125457764, -0.2564108967781067, 0.4833852052688599,
  -0.5280983448028564, -0.224007785320282, -0.3340466916561127,
  -0.5300114154815674, -0.216147854924202, 0.1847081780433655,
  -0.5245220065116882, 0.1611284017562866, 0.224007785320282,
  -0.5228362083435059, 0.2004280090332031, 0.5226848125457764,
  -0.5226848125457764, 0.3993856608867645, 0.8056420087814331,
  -0.5226848125457764, 0.7160437703132629, 0.6091439723968506,
  -0.5226848125457764, 0.736441969871521, 0.3340466916561127,
  -0.5148249268531799, -0.8685213923454285, 0.4401257932186127,
  -0.5148249268531799, -0.6563035249710083, 0.812757134437561,
  -0.5179239511489868, -0.2947470843791962, -0.7113229632377625,
  -0.515706479549408, -0.2475875467061996, -0.381206214427948,
  -0.5178142786026001, -0.2397276312112808, 0.1768482476472855,
  -0.5169207453727722, 0.1689883321523666, 0.0746692642569542,
  -0.5196659564971924, 0.1925680935382843, -0.5305447578430176,
  -0.5148249268531799, 0.2633073925971985, 0.7202188372612, -0.5148249268531799,
  0.6798832416534424, -0.8049490451812744, -0.5148249268531799,
  0.7424426674842834, 0.0039299610070884, -0.5090479850769043,
  -0.8921011686325073, 0.302606999874115, -0.5069649815559387,
  -0.7747867703437805, -0.7977821230888367, -0.5102622509002686,
  -0.3340466916561127, 0.7427626252174377, -0.5134538412094116,
  -0.2633073925971985, -0.5069649815559387, -0.5069649815559387,
  -0.2583874464035034, 0.0982490256428719, -0.5141196846961975,
  0.1847081780433655, -0.4205058217048645, -0.5069649815559387,
  0.1939245313405991, 0.318326860666275, -0.5107166171073914,
  0.2790272235870361, -0.7820622324943542, -0.5077124834060669,
  0.6956031322479248, -0.7899221777915955, -0.5120841264724731,
  0.7427626252174377, 0.1611284017562866, -0.4991050660610199,
  -0.9151627421379089, -0.1847081780433655, -0.4991050660610199,
  -0.8249201774597168, -0.6798832416534424, -0.4991050660610199,
  -0.4657772183418274, 0.7977821230888367, -0.5022736191749573,
  -0.2868871688842773, -0.5619844198226929, -0.5048304200172424,
  -0.2633073925971985, -0.3576264679431915, -0.5011425018310547,
  0.1925680935382843, -0.2082879394292831, -0.4991050660610199,
  0.2015834450721741, -0.3419066071510315, -0.5046606659889221,
  0.2711673080921173, 0.7113229632377625, -0.4991050660610199, 0.67486971616745,
  -0.8135019540786743, -0.4991050660610199, 0.7473234534263611,
  -0.2004280090332031, -0.4912451505661011, -0.9084973931312561,
  0.2475875467061996, -0.4982706904411316, -0.8056420087814331,
  -0.7427626252174377, -0.4912451505661011, -0.396926075220108,
  -0.8056460618972778, -0.4981319308280945, -0.2868871688842773,
  -0.5226848125457764, -0.4912451505661011, -0.2827473878860474,
  0.0589494146406651, -0.4958032369613647, 0.2082879394292831,
  -0.3733462989330292, -0.4936668276786804, 0.2318677008152008,
  -0.5541245341300964, -0.4912451505661011, 0.381206214427948,
  -0.8238642811775208, -0.493123471736908, 0.7270427942276001,
  -0.6563035249710083, -0.4912451505661011, 0.7428276538848877,
  0.4676653742790222, -0.4844450056552887, -0.8763813376426697,
  0.475525289773941, -0.4833852052688599, -0.6237607002258301,
  -0.8763813376426697, -0.4833852052688599, -0.3254329860210419,
  -0.6563035249710083, -0.4889725148677826, -0.2947470843791962,
  0.381206214427948, -0.4884462058544159, 0.2082879394292831,
  -0.0196498055011034, -0.4852303862571716, 0.2318677008152008,
  -0.4912451505661011, -0.4842858016490936, 0.302606999874115,
  0.7427626252174377, -0.4848605096340179, 0.7191829085350037,
  -0.7349027395248413, -0.4833852052688599, 0.7501571178436279,
  0.3261867761611938, -0.4807895720005035, -0.9156809449195862,
  -0.2790272235870361, -0.475525289773941, -0.8232282996177673,
  0.6798832416534424, -0.475525289773941, -0.4283657670021057,
  -0.8126763701438904, -0.4756641685962677, -0.3104669153690338,
  0.3576264679431915, -0.4774891436100006, -0.302606999874115,
  0.1689883321523666, -0.475525289773941, 0.2237331420183182,
  -0.1925680935382843, -0.475525289773941, 0.2398402392864227,
  0.4126459062099457, -0.475525289773941, 0.4126459062099457,
  -0.8333767056465149, -0.4831726849079132, 0.7349027395248413,
  0.5619844198226929, -0.475525289773941, 0.7525930404663086, 0.318326860666275,
  -0.4676653742790222, -0.8866613507270813, -0.5069649815559387,
  -0.4707562327384949, -0.6484435796737671, -0.8685213923454285,
  -0.4676653742790222, -0.3420979678630829, -0.6484435796737671,
  -0.4676653742790222, -0.3137187957763672, -0.2711673080921173,
  -0.4729838073253632, 0.2318677008152008, -0.3261867761611938,
  -0.4676653742790222, 0.2475875467061996, -0.4612619578838348,
  -0.4676653742790222, 0.3115216195583344, 0.7270427942276001,
  -0.4705181419849396, 0.7270427942276001, 0.6563035249710083,
  -0.4676653742790222, 0.7542520761489868, 0.3654863834381104,
  -0.4598054587841034, -0.9024882912635803, 0.4047859907150269,
  -0.4598054587841034, -0.7018234133720398, 0.8056420087814331,
  -0.4598054587841034, -0.3565914928913116, -0.6798832416534424,
  -0.4646079242229462, -0.318326860666275, -0.3340466916561127,
  -0.4604836702346802, 0.2397276312112808, -0.0668093413114548,
  -0.4609665870666504, 0.2554474771022797, 0.4205058217048645,
  -0.4598054587841034, 0.3890661597251892, 0.7772080898284912,
  -0.4598054587841034, 0.7310113906860352, 0.6484435796737671,
  -0.4598054587841034, 0.7592837810516357, -0.1454085558652878,
  -0.4519455134868622, -0.9092324376106262, 0.3890661597251892,
  -0.4519455134868622, -0.7191829085350037, 0.7993485331535339,
  -0.4519455134868622, -0.3657583892345428, 0.6405836343765259,
  -0.4594069123268127, -0.3261867761611938, -0.396926075220108,
  -0.4526145756244659, 0.2475875467061996, -0.0903891026973724,
  -0.4568284749984741, 0.2633073925971985, 0.4519455134868622,
  -0.4519455134868622, 0.4062665700912476, 0.7820622324943542,
  -0.4581500589847565, 0.7427626252174377, -0.6091439723968506,
  -0.4519455134868622, 0.760187566280365, 0.2397276312112808,
  -0.4486532509326935, -0.907820999622345, 0.4047859907150269,
  -0.4440855979919434, -0.6877431869506836, -0.8571996092796326,
  -0.4440855979919434, -0.3666006326675415, -0.6484435796737671,
  -0.4440855979919434, -0.341173529624939, -0.302606999874115,
  -0.4450944662094116, 0.2554474771022797, 0.0432295724749565,
  -0.4462704658508301, 0.2790272235870361, 0.4912451505661011,
  -0.4440855979919434, 0.4756705164909363, 0.8135019540786743,
  -0.4440855979919434, 0.7581103444099426, -0.4991050660610199,
  -0.4362256824970245, -0.9492993354797363, 0.0982490256428719,
  -0.4362256824970245, -0.8637837767601013, 0.6012840270996094,
  -0.4362256824970245, -0.4991050660610199, -0.8330295085906982,
  -0.4430094957351685, -0.3497665226459503, -0.4912451505661011,
  -0.4362256824970245, -0.3475784957408905, 0.0746692642569542,
  -0.4362256824970245, 0.263947606086731, 0.0903891026973724,
  -0.4362256824970245, 0.3237172365188599, 0.6720233559608459,
  -0.4362256824970245, 0.7191829085350037, 0.7532710433006287,
  -0.4362256824970245, 0.7646063566207886, 0.216147854924202,
  -0.4283657670021057, -0.9156809449195862, -0.4485364258289337,
  -0.4283657670021057, -0.7349027395248413, -0.8386173248291016,
  -0.4287863671779633, -0.381206214427948, -0.6563035249710083,
  -0.4345864951610565, -0.3497665226459503, -0.2397276312112808,
  -0.4283657670021057, 0.2703794836997986, -0.0746692642569542,
  -0.4283657670021057, 0.3017107546329498, 0.538404643535614,
  -0.4283657670021057, 0.5855641961097717, 0.8392006754875183,
  -0.430512547492981, 0.7663424015045166, -0.2554474771022797,
  -0.4205058217048645, -0.9585467576980591, 0.0589494146406651,
  -0.4253355860710144, -0.8685213923454285, -0.6405836343765259,
  -0.4205058217048645, -0.5360852479934692, 0.8056420087814331,
  -0.4205058217048645, -0.3703610599040985, -0.4676653742790222,
  -0.4205058217048645, -0.3627447783946991, 0.1532684862613678,
  -0.4205058217048645, 0.2866291701793671, -0.4283657670021057,
  -0.4205058217048645, 0.3419066071510315, 0.6979548931121826,
  -0.4205058217048645, 0.7210032343864441, 0.7584825158119202,
  -0.4205058217048645, 0.7694959044456482, -0.0746692642569542,
  -0.4126459062099457, -0.9347898364067078, -0.3733462989330292,
  -0.4126459062099457, -0.7899221777915955, 0.7748232483863831,
  -0.4126459062099457, -0.4012967348098755, -0.7034630179405212,
  -0.4181294143199921, -0.3654863834381104, -0.2004280090332031,
  -0.4201342761516571, 0.2790272235870361, 0.1689883321523666,
  -0.4126459062099457, 0.3068793714046478, -0.5619844198226929,
  -0.4126459062099457, 0.5462645888328552, -0.8854278922080994,
  -0.4126459062099457, 0.7673639059066772, -0.4912451505661011,
  -0.4111657738685608, -0.9549805521965027, 0.1689883321523666,
  -0.4047859907150269, -0.8514509201049805, -0.7113229632377625,
  -0.4047859907150269, -0.4519455134868622, 0.7581904530525208,
  -0.4120258092880249, -0.3733462989330292, -0.3497665226459503,
  -0.4085805416107178, 0.2868871688842773, -0.224007785320282,
  -0.4047859907150269, 0.2992872595787048, 0.3576264679431915,
  -0.4047859907150269, 0.4519455134868622, 0.7878223657608032,
  -0.4047859907150269, 0.7559878826141357, 0.5619844198226929,
  -0.396926075220108, -0.9684425592422485, 0.0589494146406651,
  -0.396926075220108, -0.8802880644798279, 0.5934241414070129,
  -0.396926075220108, -0.5143404006958008, -0.829221785068512,
  -0.396926075220108, -0.3879621624946594, -0.4205058217048645,
  -0.396926075220108, -0.3875879645347595, 0.3654863834381104,
  -0.4010163843631744, 0.302606999874115, 0.3654863834381104,
  -0.396926075220108, 0.4047859907150269, 0.7630699276924133,
  -0.396926075220108, 0.7522133588790894, -0.6641634106636047,
  -0.396926075220108, 0.7752193808555603, -0.1061089485883713,
  -0.3890661597251892, -0.9314007759094238, -0.4532742500305176,
  -0.3890661597251892, -0.737005889415741, -0.8449416160583496,
  -0.394212394952774, -0.4047859907150269, -0.6405836343765259,
  -0.3890661597251892, -0.3922198414802551, 0.0196498055011034,
  -0.3952685296535492, 0.3104669153690338, -0.4833852052688599,
  -0.3890661597251892, 0.3576264679431915, 0.6762821674346924,
  -0.3890661597251892, 0.7427626252174377, -0.7322928309440613,
  -0.3890661597251892, 0.7770397067070007, -0.0275097284466028,
  -0.381206214427948, -0.939260721206665, 0.3863629698753357,
  -0.381206214427948, -0.7270427942276001, 0.8088985681533813,
  -0.381206214427948, -0.4193814694881439, 0.6248638033866882,
  -0.3842673301696777, -0.396926075220108, 0.1532684862613678,
  -0.381206214427948, 0.3073278069496155, 0.0432295724749565,
  -0.381206214427948, 0.3544542193412781, 0.6405836343765259,
  -0.381206214427948, 0.731225311756134, -0.7977821230888367,
  -0.381206214427948, 0.778243362903595, 0.1139688715338707,
  -0.3733462989330292, -0.9428212642669678, 0.381206214427948,
  -0.3733462989330292, -0.7250815629959106, -0.8528015613555908,
  -0.3733462989330292, -0.4163201153278351, -0.6248638033866882,
  -0.3733462989330292, -0.4081171154975891, 0.4205058217048645,
  -0.3733462989330292, 0.3124141693115234, -0.0117898834869266,
  -0.3733462989330292, 0.3733462989330292, -0.7731760144233704,
  -0.3733462989330292, 0.7400771379470825, 0.7191829085350037,
  -0.3733462989330292, 0.7775857448577881, 0.4047859907150269,
  -0.3684949576854706, -0.9235408306121826, 0.4833852052688599,
  -0.3654863834381104, -0.6311824321746826, 0.8449416160583496,
  -0.3654863834381104, -0.4129260778427124, 0.3340466916561127,
  -0.3692875802516937, 0.318326860666275, -0.3340466916561127,
  -0.3654863834381104, 0.3371888101100922, -0.5619844198226929,
  -0.3654863834381104, 0.6012840270996094, -0.8825786113739014,
  -0.3668482303619385, 0.7820622324943542, -0.1925680935382843,
  -0.3576264679431915, -0.9628404378890991, -0.320746123790741,
  -0.3576264679431915, -0.8496933579444885, 0.7191829085350037,
  -0.3576264679431915, -0.4399291574954987, -0.7349027395248413,
  -0.3618295788764954, -0.4126459062099457, -0.1139688715338707,
  -0.3576264679431915, 0.3244619071483612, -0.2947470843791962,
  -0.3576264679431915, 0.3550065159797668, 0.5777042508125305,
  -0.3576264679431915, 0.7113229632377625, -0.8266491293907166,
  -0.3576264679431915, 0.7809021472930908, 0.4205058217048645,
  -0.3497665226459503, -0.965121865272522, 0.2790272235870361,
  -0.3497665226459503, -0.8135019540786743, -0.8159412145614624,
  -0.3497665226459503, -0.4365502297878265, 0.6170039176940918,
  -0.3543760478496552, -0.4205058217048645, 0.318326860666275,
  -0.3497665226459503, 0.3270520865917206, -0.2082879394292831,
  -0.3497665226459503, 0.3810768127441406, -0.7584825158119202,
  -0.3497665226459503, 0.7398403882980347, 0.7427626252174377,
  -0.3497665226459503, 0.7852312326431274, 0.0117898834869266,
  -0.3419066071510315, -0.9471206068992615, -0.4561232626438141,
  -0.3487899899482727, -0.7270427942276001, 0.8135019540786743,
  -0.3419066071510315, -0.42924565076828, -0.5619844198226929,
  -0.3419066071510315, -0.4275921881198883, 0.2633073925971985,
  -0.3419066071510315, 0.3558961749076843, -0.6012840270996094,
  -0.3419066071510315, 0.6329230666160583, 0.829221785068512,
  -0.3419066071510315, 0.7871463298797607, -0.137548640370369,
  -0.3340466916561127, -0.9576557874679565, -0.4047859907150269,
  -0.3340466916561127, -0.750622570514679, -0.8468925356864929,
  -0.3340466916561127, -0.4369976222515106, 0.5305447578430176,
  -0.3402267694473267, -0.4283657670021057, 0.2554474771022797,
  -0.3340466916561127, 0.3346047401428223, 0.0196498055011034,
  -0.3340466916561127, 0.4031403958797455, 0.7427626252174377,
  -0.3340466916561127, 0.7656468152999878, 0.5934241414070129,
  -0.3261867761611938, -0.9935120940208435, -0.0196498055011034,
  -0.3261867761611938, -0.8979380130767822, -0.6484435796737671,
  -0.3261867761611938, -0.5148249268531799, -0.8100387454032898,
  -0.3261867761611938, -0.4327654838562012, -0.3419066071510315,
  -0.329423576593399, 0.3497665226459503, -0.4912451505661011,
  -0.3261867761611938, 0.4642056524753571, 0.7742023468017578,
  -0.3261867761611938, 0.7820622324943542, 0.4898223578929901,
  -0.3188047111034393, -0.9942801594734192, 0.0275097284466028,
  -0.318326860666275, -0.8921011686325073, -0.6689959764480591,
  -0.318829357624054, -0.4991050660610199, 0.7584825158119202,
  -0.318326860666275, -0.4370164573192596, -0.1611284017562866,
  -0.3201496601104736, 0.3419066071510315, 0.1061089485883713,
  -0.3250637054443359, 0.3733462989330292, -0.6563035249710083,
  -0.318326860666275, 0.6936169266700745, 0.7977821230888367,
  -0.318326860666275, 0.7897136211395264, 0.318326860666275,
  -0.3104669153690338, -0.975388765335083, -0.318326860666275,
  -0.3104669153690338, -0.8056420087814331, -0.8242979645729065,
  -0.3104669153690338, -0.458916038274765, 0.6641634106636047,
  -0.3104669153690338, 0.3476866483688354, -0.2633073925971985,
  -0.3104669153690338, 0.3864366114139557, -0.6956031322479248,
  -0.3104669153690338, 0.7467120289802551, 0.7349027395248413,
  -0.3104669153690338, 0.7923495173454285, 0.0903891026973724,
  -0.302606999874115, -0.9536512494087219, -0.475525289773941,
  -0.302606999874115, -0.6405836343765259, 0.8374972939491272,
  -0.302606999874115, -0.4440855979919434, -0.1719377189874649,
  -0.3098795413970947, 0.3497665226459503, -0.3261867761611938,
  -0.302606999874115, 0.3679747581481934, -0.5619844198226929,
  -0.302606999874115, 0.6720233559608459, 0.8096776604652405,
  -0.302606999874115, 0.7941011190414429, -0.0589494146406651,
  -0.2947470843791962, -0.9584817290306091, -0.4598054587841034,
  -0.2947470843791962, -0.6720233559608459, 0.8416966199874878,
  -0.2947470843791962, -0.447481632232666, -0.396926075220108,
  -0.2947470843791962, 0.3553339540958405, -0.302606999874115,
  -0.2947470843791962, 0.396466851234436, -0.7191829085350037,
  -0.2947470843791962, 0.75652676820755, -0.7349027395248413,
  -0.2947470843791962, 0.7930549383163452, 0.4283657670021057,
  -0.2868871688842773, -0.9190755486488342, 0.5698443651199341,
  -0.2868871688842773, -0.5305447578430176, 0.7686586976051331,
  -0.2868871688842773, -0.4525546133518219, 0.2554474771022797,
  -0.2868871688842773, 0.3569115400314331, 0.2004280090332031,
  -0.2868871688842773, 0.4440855979919434, -0.7994250655174255,
  -0.2868871688842773, 0.777851402759552, 0.5619844198226929,
  -0.2790272235870361, -0.9880684018135071, -0.2397276312112808,
  -0.2790272235870361, -0.8608717322349548, 0.7270427942276001,
  -0.2790272235870361, -0.4673337638378143, -0.6956031322479248,
  -0.2790272235870361, -0.4553340375423431, 0.2711673080921173,
  -0.2790272235870361, 0.3622964024543762, 0.2947470843791962,
  -0.2790272235870361, 0.5343608856201172, 0.8056420087814331,
  -0.2790272235870361, 0.796303927898407, -0.3497665226459503,
  -0.2711673080921173, -0.9943011403083801, 0.137548640370369,
  -0.2711673080921173, -0.8617212176322937, 0.7270427942276001,
  -0.2711673080921173, -0.4746296405792236, 0.7034630179405212,
  -0.2711673080921173, 0.3627201318740845, -0.2633073925971985,
  -0.2711673080921173, 0.398354709148407, -0.6877431869506836,
  -0.2711673080921173, 0.7636597752571106, -0.7113229632377625,
  -0.2711673080921173, 0.7991421222686768, 0.0275097284466028,
  -0.2633073925971985, -0.9516177177429199, 0.475525289773941,
  -0.2633073925971985, -0.6039822697639465, 0.8056420087814331,
  -0.2633073925971985, -0.4609285593032837, 0.0982490256428719,
  -0.2633073925971985, 0.3634000420570374, -0.0668093413114548,
  -0.2633073925971985, 0.4114764630794525, -0.750622570514679,
  -0.2633073925971985, 0.7716858983039856, -0.6720233559608459,
  -0.2633073925971985, 0.7990660071372986, 0.3654863834381104,
  -0.2554474771022797, -0.9139918684959412, -0.6327237486839294,
  -0.2554474771022797, -0.4991050660610199, 0.7472633719444275,
  -0.2554474771022797, -0.4634167551994324, 0.0668093413114548,
  -0.2554474771022797, 0.3664529323577881, 0.1061089485883713,
  -0.2554474771022797, 0.5069649815559387, 0.787431538105011,
  -0.2554474771022797, 0.7960749864578247, 0.475525289773941,
  -0.2475875467061996, -0.9889203310012817, 0.2082879394292831,
  -0.2475875467061996, -0.8046198487281799, -0.829221785068512,
  -0.2475875467061996, -0.4647635221481323, -0.5069649815559387,
  -0.2475875467061996, 0.3687294721603394, 0.0903891026973724,
  -0.249998077750206, 0.475525289773941, -0.8135019540786743,
  -0.2488442063331604, 0.7977821230888367, -0.538404643535614,
  -0.2397276312112808, -0.9929960370063782, -0.1925680935382843,
  -0.2397276312112808, -0.8336226940155029, 0.7742023468017578,
  -0.2397276312112808, -0.4676653742790222, -0.0604376047849655,
  -0.2397276312112808, 0.37059685587883, -0.1454085558652878,
  -0.2397276312112808, 0.4186291396617889, -0.7584825158119202,
  -0.2397276312112808, 0.7774254083633423, -0.6563035249710083,
  -0.2318677008152008, -0.9994264841079712, 0.0275097284466028,
  -0.2318677008152008, -0.8725227117538452, 0.7034630179405212,
  -0.2318677008152008, -0.4806902706623077, 0.6798832416534424,
  -0.2322017103433609, -0.4676653742790222, 0.4362256824970245,
  -0.2318677008152008, 0.3786943554878235, 0.3419066071510315,
  -0.2318677008152008, 0.6012840270996094, 0.8400182723999023,
  -0.2324923723936081, 0.8056420087814331, -0.1532684862613678,
  -0.224007785320282, -0.9743818044662476, -0.3733462989330292,
  -0.224007785320282, -0.7113229632377625, -0.8686830401420593,
  -0.224007785320282, -0.4688185751438141, -0.302606999874115,
  -0.224007785320282, 0.3751629292964935, -0.1847081780433655,
  -0.224007785320282, 0.4362256824970245, -0.7860564589500427,
  -0.224007785320282, 0.7899221777915955, 0.5418291091918945,
  -0.224007785320282, 0.8064972758293152, 0.1296887099742889,
  -0.216147854924202, -0.9314007759094238, 0.5490822792053223,
  -0.216147854924202, -0.5441892743110657, 0.7663424015045166,
  -0.216147854924202, -0.4710248112678528, 0.3576264679431915,
  -0.216147854924202, 0.4024985134601593, -0.6248638033866882,
  -0.2180063426494598, 0.7584825158119202, 0.7270427942276001,
  -0.216147854924202, 0.80791836977005, 0.0668093413114548, -0.2082879394292831,
  -0.9549805521965027, 0.4729267060756683, -0.2082879394292831,
  -0.6012840270996094, 0.7990181446075439, -0.2082879394292831,
  -0.4731575846672058, 0.137548640370369, -0.2082879394292831,
  0.3927251696586609, -0.5305447578430176, -0.2082879394292831,
  0.6956031322479248, -0.8396907448768616, -0.2082879394292831,
  0.8091790676116943, -0.0432295724749565, -0.2004280090332031,
  -0.962996780872345, -0.4598054587841034, -0.2004280090332031,
  -0.6877431869506836, 0.8338168859481812, -0.2004280090332031,
  -0.4748747050762177, -0.1218287944793701, -0.2004280090332031,
  0.3820758461952209, 0.2318677008152008, -0.2004280090332031,
  0.6012840270996094, -0.882792055606842, -0.2004280090332031,
  0.8103695511817932, -0.1925680935382843, -0.1925680935382843,
  -0.9631129503250122, -0.4519455134868622, -0.1925680935382843,
  -0.6982787847518921, 0.829221785068512, -0.1939778476953506,
  -0.475525289773941, 0.0982490256428719, -0.1925680935382843,
  0.3845127820968628, -0.318326860666275, -0.1925680935382843,
  0.4357833564281464, -0.7820622324943542, -0.1978255361318588,
  0.7977821230888367, -0.5777042508125305, -0.1847081780433655,
  -0.9785603284835815, -0.2545910179615021, -0.1847081780433655,
  -0.8710739612579346, -0.7427626252174377, -0.1847081780433655,
  -0.478694349527359, -0.6091439723968506, -0.1847081780433655,
  -0.4754266440868378, 0.4598054587841034, -0.1847081780433655,
  0.4205058217048645, 0.6639766693115234, -0.1847081780433655,
  0.7802493572235107, 0.6327237486839294, -0.1794079095125198,
  -0.986420214176178, 0.0275097284466028, -0.1768482476472855,
  -0.9188060760498047, -0.6091439723968506, -0.1768482476472855,
  -0.5305447578430176, 0.7566667199134827, -0.182659238576889,
  -0.475525289773941, 0.2475875467061996, -0.1768482476472855,
  0.3898423612117767, -0.396926075220108, -0.1768482476472855,
  0.6798832416534424, -0.8468441367149353, -0.1794121712446213,
  0.8135019540786743, 0.0589494146406651, -0.1689883321523666,
  -0.9726088047027588, 0.2475875467061996, -0.1689883321523666,
  -0.7977821230888367, 0.7913528680801392, -0.1689883321523666,
  -0.4764386415481567, -0.2711673080921173, -0.1689883321523666,
  0.387994796037674, 0.2633073925971985, -0.1689883321523666,
  0.5777042508125305, -0.8761731386184692, -0.1768096834421158,
  0.8135019540786743, -0.2554474771022797, -0.1611284017562866,
  -0.9750860333442688, -0.1768482476472855, -0.1611284017562866,
  -0.8816884160041809, 0.6641634106636047, -0.1611284017562866,
  -0.4845297336578369, 0.6563035249710083, -0.1611284017562866,
  0.3865334093570709, -0.1611284017562866, -0.1611284017562866,
  0.4362364709377289, 0.7349027395248413, -0.1611284017562866, 0.80067378282547,
  -0.5855641961097717, -0.1532684862613678, -0.9717031717300415,
  -0.1847081780433655, -0.1580039113759995, -0.8999611139297485,
  0.6091439723968506, -0.1532684862613678, -0.4912451505661011,
  -0.744191586971283, -0.1532684862613678, 0.3890661597251892,
  -0.2669961154460907, -0.1532684862613678, 0.4283657670021057,
  -0.7476937174797058, -0.1532684862613678, 0.786802351474762,
  -0.6641634106636047, -0.1454085558652878, -0.9707803726196289,
  -0.0903891026973724, -0.1454085558652878, -0.9155797362327576,
  0.5541245341300964, -0.1454085558652878, -0.5305447578430176,
  -0.7994759082794189, -0.1454085558652878, -0.4785006940364838,
  0.538404643535614, -0.1454085558652878, 0.4202225506305695,
  -0.6877431869506836, -0.1454085558652878, 0.775617778301239,
  -0.7349027395248413, -0.1454085558652878, 0.8155990839004517,
  0.4519455134868622, -0.137548640370369, -0.9242639541625977,
  -0.5698443651199341, -0.137548640370369, -0.5855641961097717,
  0.7904314398765564, -0.137548640370369, -0.4769718050956726,
  0.3733462989330292, -0.137548640370369, 0.4021980762481689,
  0.4833852052688599, -0.137548640370369, 0.7571150064468384,
  0.7663424015045166, -0.137548640370369, 0.8187059760093689,
  0.2868871688842773, -0.1296887099742889, -0.9314007759094238,
  0.5005152225494385, -0.1296887099742889, -0.5777042508125305,
  -0.8307536840438843, -0.1296887099742889, -0.4768047332763672,
  0.3576264679431915, -0.1296887099742889, 0.40254145860672, 0.4833852052688599,
  -0.1296887099742889, 0.7508152723312378, 0.7742023468017578,
  -0.1296887099742889, 0.8198735117912292, 0.2947470843791962,
  -0.1218287944793701, -0.948444664478302, 0.4519455134868622,
  -0.1218287944793701, -0.6371440887451172, -0.8685213923454285,
  -0.1218287944793701, -0.4776720404624939, 0.1611284017562866,
  -0.1218287944793701, 0.4012471437454224, 0.4676653742790222,
  -0.1218287944793701, 0.750622570514679, 0.7750073075294495,
  -0.1218287944793701, 0.8213618397712708, 0.2189894318580627,
  -0.1139688715338707, -0.9511134624481201, -0.4205058217048645,
  -0.1170618832111359, -0.750622570514679, 0.8056420087814331,
  -0.1139688715338707, -0.4778968393802643, -0.1611284017562866,
  -0.1139688715338707, 0.3933739066123962, 0.2868871688842773,
  -0.1139688715338707, 0.6405836343765259, -0.8643186092376709,
  -0.1139688715338707, 0.8210716247558594, 0.4362256824970245,
  -0.1061089485883713, -0.948062002658844, -0.4519455134868622,
  -0.1061089485883713, -0.8056420087814331, -0.8284065127372742,
  -0.1061089485883713, -0.4756986498832703, -0.2868871688842773,
  -0.1061089485883713, 0.3914571404457092, -0.1925680935382843,
  -0.1077636033296585, 0.4912451505661011, -0.8213618397712708,
  -0.1061089485883713, 0.8058863282203674, 0.5462645888328552,
  -0.1020311713218689, -0.9549805521965027, 0.1689883321523666,
  -0.1011415719985962, -0.860661506652832, 0.6877431869506836,
  -0.0982490256428719, -0.4786837100982666, -0.6327237486839294,
  -0.0982490256428719, -0.4744169414043427, 0.4362256824970245,
  -0.0982490256428719, 0.4264353215694427, -0.7349027395248413,
  -0.0982490256428719, 0.7837456464767456, 0.6720233559608459,
  -0.0956475660204887, -0.9549805521965027, -0.0117898834869266,
  -0.0903891026973724, -0.888841450214386, -0.6405836343765259,
  -0.0903891026973724, -0.4924151301383972, -0.7742023468017578,
  -0.0903891026973724, -0.4738195538520813, 0.318326860666275,
  -0.0903891026973724, 0.4205058217048645, -0.6934643983840942,
  -0.0903891026973724, 0.7785954475402832, 0.7034630179405212,
  -0.0903891026973724, 0.8243509531021118, 0.4440855979919434,
  -0.082529179751873, -0.8831032514572144, 0.6091439723968506,
  -0.082529179751873, -0.4912451505661011, 0.7364121079444885,
  -0.082529179751873, -0.4724915325641632, 0.3419066071510315,
  -0.082529179751873, 0.4110410809516907, 0.5777042508125305,
  -0.082529179751873, 0.7805584073066711, -0.750622570514679,
  -0.082529179751873, 0.8264100551605225, 0.396926075220108,
  -0.0746692642569542, -0.8888830542564392, 0.5855641961097717,
  -0.0746692642569542, -0.4912451505661011, 0.738078773021698,
  -0.0746692642569542, -0.4715659618377686, 0.475525289773941,
  -0.0746692642569542, 0.4153229296207428, -0.6641634106636047,
  -0.0746692642569542, 0.7751261591911316, 0.7349027395248413,
  -0.0746692642569542, 0.8271068930625916, 0.4362256824970245,
  -0.0668093413114548, -0.8950298428535461, -0.6091439723968506,
  -0.0668093413114548, -0.5305447578430176, -0.8084772825241089,
  -0.0668093413114548, -0.469558447599411, 0.4519455134868622,
  -0.0668093413114548, 0.4126459062099457, 0.6060845851898193,
  -0.0668093413114548, 0.7775396108627319, 0.7270427942276001,
  -0.0668093413114548, 0.8293303251266479, -0.4047859907150269,
  -0.0589494146406651, -0.9462189078330994, -0.3340466916561127,
  -0.0589494146406651, -0.7191829085350037, -0.8510792255401611,
  -0.0589494146406651, -0.4712458550930023, -0.1218287944793701,
  -0.0589494146406651, 0.3909663558006287, 0.2633073925971985,
  -0.0589494146406651, 0.6091439723968506, -0.8783425092697144,
  -0.0589494146406651, 0.8306067585945129, -0.4126459062099457,
  -0.0510894954204559, -0.9455796480178833, -0.3104669153690338,
  -0.0510894954204559, -0.7820622324943542, -0.8305182456970215,
  -0.0545891970396042, -0.4676653742790222, -0.3104669153690338,
  -0.0510894954204559, -0.4661144614219666, 0.4205058217048645,
  -0.0510894954204559, 0.403071790933609, -0.5777042508125305,
  -0.0510894954204559, 0.7113229632377625, -0.8347702026367188,
  -0.0510894954204559, 0.8328040838241577, 0.0275097284466028,
  -0.0432295724749565, -0.9440323114395142, 0.3340466916561127,
  -0.0432295724749565, -0.6720233559608459, -0.8657578229904175,
  -0.0432295724749565, -0.4718017280101776, 0.6877431869506836,
  -0.0432295724749565, 0.3877026438713074, 0.082529179751873,
  -0.0432295724749565, 0.4833852052688599, -0.824019730091095,
  -0.0432295724749565, 0.8213618397712708, 0.5133540630340576,
  -0.0353696495294571, -0.9454424381256104, -0.0589494146406651,
  -0.0353696495294571, -0.820258617401123, 0.7742023468017578,
  -0.0353696495294571, -0.4718438982963562, 0.7113229632377625,
  -0.0353696495294571, 0.3870458900928497, -0.1689883321523666,
  -0.0353696495294571, 0.4235611259937286, 0.7270427942276001,
  -0.0353696495294571, 0.8051181435585022, 0.6012840270996094,
  -0.0275097284466028, -0.9425769448280334, -0.2711673080921173,
  -0.0275097284466028, -0.8396469950675964, -0.7584825158119202,
  -0.0275097284466028, -0.4647896885871887, -0.6405836343765259,
  -0.0275097284466028, 0.3862249255180359, -0.2004280090332031,
  -0.0275097284466028, 0.4237120151519775, 0.7349027395248413,
  -0.0275097284466028, 0.8048225045204163, 0.6091439723968506,
  -0.0196498055011034, -0.9412328004837036, -0.2790272235870361,
  -0.0196498055011034, -0.8495471477508545, -0.7191829085350037,
  -0.0259850211441517, -0.4676653742790222, 0.6956031322479248,
  -0.0196498055011034, -0.4585400223731995, -0.5305447578430176,
  -0.0196498055011034, 0.389426052570343, -0.4205058217048645,
  -0.0196498055011034, 0.650249183177948, -0.860661506652832,
  -0.0243689846247435, 0.8370817303657532, -0.1139688715338707,
  -0.0117898834869266, -0.941613495349884, 0.0510894954204559,
  -0.0162541456520557, -0.8213618397712708, 0.7663424015045166,
  -0.0117898834869266, -0.4598054587841034, -0.0713778808712959,
  -0.0117898834869266, -0.4560623466968536, 0.4676653742790222,
  -0.0117898834869266, 0.3996247947216034, 0.5698443651199341,
  -0.0117898834869266, 0.7820622324943542, -0.7871189713478088,
  -0.0117898834869266, 0.8390175700187683, -0.1611284017562866,
  -0.0039299610070884, -0.9387778639793396, -0.2711673080921173,
  -0.0039299610070884, -0.6958083510398865, -0.8528015613555908,
  -0.0039299610070884, -0.4564415812492371, -0.2004280090332031,
  -0.0039299610070884, 0.381614476442337, 0.1689883321523666,
  -0.0039299610070884, 0.538404643535614, 0.8250893950462341,
  -0.0039299610070884, 0.8360271453857422, 0.4676653742790222,
  0.0039299610070884, -0.9358096122741699, -0.4047859907150269,
  0.0039299610070884, -0.8522207140922546, -0.6956031322479248,
  0.0039299610070884, -0.4610361456871033, -0.7034630179405212,
  0.0039299610070884, -0.4517750442028046, -0.5462645888328552,
  0.0039299610070884, 0.380865603685379, 0.2554474771022797, 0.0039299610070884,
  0.5069649815559387, 0.8065924644470215, 0.0039299610070884,
  0.8327555060386658, -0.5305447578430176, 0.0117898834869266,
  -0.9378558993339539, -0.0117898834869266, 0.0117898834869266,
  -0.7820622324943542, -0.8247054815292358, 0.0117898834869266,
  -0.4523427486419678, -0.082529179751873, 0.0117898834869266,
  -0.4486914575099945, 0.5069649815559387, 0.0117898834869266,
  0.3914049565792084, 0.5462645888328552, 0.0117898834869266,
  0.7427626252174377, 0.7856863737106323, 0.0117898834869266,
  0.8424304723739624, 0.137548640370369, 0.0196498055011034,
  -0.8965931534767151, 0.5226848125457764, 0.0196498055011034,
  -0.5342411398887634, -0.829221785068512, 0.0196498055011034,
  -0.4492707252502441, 0.0668093413114548, 0.0196498055011034,
  0.3810812532901764, 0.396926075220108, 0.0196498055011034, 0.5934241414070129,
  -0.8867777585983276, 0.0196498055011034, 0.843143105506897,
  -0.2790272235870361, 0.0275097284466028, -0.9340113997459412,
  0.318326860666275, 0.0275097284466028, -0.6798832416534424,
  0.8152145743370056, 0.0275097284466028, -0.446891188621521,
  -0.0982490256428719, 0.0275097284466028, 0.3745764493942261,
  -0.2475875467061996, 0.0199056230485439, 0.4126459062099457,
  0.7427626252174377, 0.0275097284466028, 0.8000109195709229,
  0.6798832416534424, 0.0275097284466028, 0.8451635241508484,
  -0.0982490256428719, 0.0275545828044415, -0.8921011686325073,
  0.5305447578430176, 0.0353696495294571, -0.5419678688049316,
  0.7977821230888367, 0.0353696495294571, -0.4409603774547577,
  -0.5462645888328552, 0.0309538412839174, 0.3733462989330292,
  -0.1532684862613678, 0.0353696495294571, 0.3839011192321777,
  0.538404643535614, 0.0353696495294571, 0.696134626865387, 0.8056420087814331,
  0.034534677863121, 0.8449416160583496, 0.3497665226459503, 0.0432295724749565,
  -0.9319309592247009, 0.1689883321523666, 0.0432295724749565,
  -0.8166201114654541, -0.7899221777915955, 0.0432295724749565,
  -0.438635915517807, -0.6012840270996094, 0.0432295724749565,
  0.3699475228786469, -0.224007785320282, 0.0432295724749565,
  0.4046494960784912, -0.7742023468017578, 0.0432295724749565,
  0.7976984977722168, 0.7034630179405212, 0.0432295724749565,
  0.8463512063026428, 0.318326860666275, 0.0510894954204559,
  -0.9293732047080994, 0.396926075220108, 0.0454271025955677,
  -0.6327237486839294, -0.8685213923454285, 0.0510894954204559,
  -0.4378349483013153, -0.0353696495294571, 0.0486198365688324,
  0.3733462989330292, -0.4440855979919434, 0.0510894954204559,
  0.396926075220108, -0.7346128821372986, 0.0478248000144958,
  0.7899221777915955, -0.7899221777915955, 0.0510894954204559,
  0.8479339480400085, 0.2475875467061996, 0.0589494146406651,
  -0.8731563091278076, 0.5619844198226929, 0.0589494146406651,
  -0.5085604190826416, 0.7820622324943542, 0.0589494146406651,
  -0.4338914752006531, -0.2082879394292831, 0.0539719611406326,
  0.3654863834381104, 0.0117898834869266, 0.0547171048820019,
  0.3890661597251892, 0.6563035249710083, 0.0589494146406651,
  0.7869837284088135, -0.8056420087814331, 0.0589494146406651,
  0.8491398692131042, 0.2318677008152008, 0.0668093413114548,
  -0.8685213923454285, -0.6149443387985229, 0.0668093413114548,
  -0.5069649815559387, 0.7835026383399963, 0.0664678886532784,
  -0.4283657670021057, 0.3576264679431915, 0.0668093413114548,
  0.3618746101856232, 0.2790272235870361, 0.0668093413114548,
  0.4912451505661011, -0.8565734624862671, 0.0601034089922905,
  0.8370817303657532, 0.5148249268531799, 0.0746692642569542,
  -0.9268983006477356, -0.082529179751873, 0.0746692642569542,
  -0.8053513765335083, 0.7584825158119202, 0.0670951381325722,
  -0.4283657670021057, -0.538404643535614, 0.0746692642569542,
  -0.4277683198451996, 0.0117898834869266, 0.0746692642569542,
  0.3577001094818115, 0.0117898834869266, 0.0746692642569542, 0.475525289773941,
  0.805381178855896, 0.0746692642569542, 0.8335503935813904,
  -0.5777042508125305, 0.082529179751873, -0.9254688024520874,
  -0.0982490256428719, 0.082529179751873, -0.8185088038444519,
  -0.7584825158119202, 0.082529179751873, -0.4354330897331238,
  0.7427626252174377, 0.082529179751873, -0.4201706945896149,
  0.4912451505661011, 0.082529179751873, 0.3581632673740387, 0.3654863834381104,
  0.082529179751873, 0.5619844198226929, -0.9009008407592773, 0.08169324696064,
  0.8528015613555908, -0.4047859907150269, 0.0873844251036644,
  -0.9235408306121826, -0.2711673080921173, 0.0903891026973724,
  -0.8685213923454285, 0.5581738352775574, 0.0903891026973724,
  -0.4912451505661011, -0.8221474885940552, 0.0832232311367989,
  -0.4205058217048645, 0.3654863834381104, 0.0890562906861305,
  0.3576264679431915, -0.4362256824970245, 0.0903891026973724,
  0.3682995140552521, 0.5934241414070129, 0.0903891026973724,
  0.7191829085350037, -0.8386791348457336, 0.0903891026973724,
  0.8540156483650208, -0.381206214427948, 0.0982490256428719,
  -0.9223470091819763, -0.216147854924202, 0.0982490256428719,
  -0.8111392259597778, 0.7191829085350037, 0.091284766793251,
  -0.4205058217048645, 0.6798832416534424, 0.0982490256428719,
  -0.4121298491954803, 0.4126459062099457, 0.0982490256428719,
  0.3549254536628723, -0.4676653742790222, 0.0982490256428719,
  0.4722385406494141, -0.8528015613555908, 0.0979675427079201,
  0.8370817303657532, -0.5777042508125305, 0.1061089485883713,
  -0.9212504625320435, -0.1847081780433655, 0.1061089485883713,
  -0.8056420087814331, 0.7340076565742493, 0.1022418364882469,
  -0.4126459062099457, -0.5698443651199341, 0.1061089485883713,
  -0.4111616909503937, -0.2475875467061996, 0.1061089485883713,
  0.3429076969623566, 0.0746692642569542, 0.1061089485883713,
  0.4047859907150269, -0.8094260692596436, 0.1061089485883713,
  0.8066469430923462, 0.7034630179405212, 0.1139688715338707,
  -0.9181292653083801, -0.4519455134868622, 0.1139688715338707,
  -0.8351560235023499, -0.6877431869506836, 0.1139688715338707,
  -0.4219402968883514, -0.7820622324943542, 0.1138202771544456,
  -0.4047859907150269, 0.5698443651199341, 0.1084960922598839,
  0.3419066071510315, 0.2475875467061996, 0.1139688715338707,
  0.3890661597251892, 0.7658552527427673, 0.1139688715338707,
  0.8107357025146484, 0.6877431869506836, 0.1218287944793701,
  -0.9161089062690735, -0.4676653742790222, 0.1218287944793701,
  -0.8310019373893738, -0.6956031322479248, 0.1218287944793701,
  -0.4205058217048645, -0.7857115864753723, 0.1218287944793701,
  -0.4015592634677887, -0.4833852052688599, 0.116299644112587,
  0.3419066071510315, -0.3733462989330292, 0.1218287944793701,
  0.3628391027450562, -0.6956031322479248, 0.1218287944793701,
  0.7349027395248413, 0.7949418425559998, 0.1218287944793701,
  0.8597070574760437, 0.0668093413114548, 0.1296887099742889,
  -0.8915765285491943, -0.5305447578430176, 0.1296887099742889,
  -0.538404643535614, -0.8686125874519348, 0.1296887099742889,
  -0.3991418778896332, 0.0668093413114548, 0.12484210729599, 0.3340466916561127,
  -0.1061089485883713, 0.1242946162819862, 0.3497665226459503,
  0.5855641961097717, 0.1296887099742889, 0.6563035249710083,
  0.8279812335968018, 0.1296887099742889, 0.8605502843856812,
  -0.1532684862613678, 0.137548640370369, -0.9158157110214233,
  0.1689883321523666, 0.137548640370369, -0.8056420087814331,
  -0.7661593556404114, 0.137548640370369, -0.3985831737518311,
  -0.7034630179405212, 0.137548640370369, -0.3941071033477783,
  -0.1847081780433655, 0.1365057080984116, 0.3340466916561127,
  -0.4519455134868622, 0.137548640370369, 0.3513132035732269,
  0.6798832416534424, 0.137548640370369, 0.7584825158119202, 0.7872005701065063,
  0.137548640370369, 0.8603035807609558, 0.4362256824970245, 0.1454085558652878,
  -0.9135315418243408, -0.3576264679431915, 0.1454085558652878,
  -0.8113909959793091, -0.7427626252174377, 0.1385523527860641,
  -0.396926075220108, -0.6798832416534424, 0.1454085558652878,
  -0.3890139758586884, -0.5462645888328552, 0.1454085558652878,
  0.3217741847038269, -0.0589494146406651, 0.139973446726799,
  0.3497665226459503, 0.6798832416534424, 0.1454085558652878,
  0.7270427942276001, -0.8390764594078064, 0.1454085558652878,
  0.8632787466049194, -0.0510894954204559, 0.1526298373937607,
  -0.8921011686325073, 0.475525289773941, 0.1532684862613678,
  -0.5462645888328552, -0.8818402290344238, 0.1532684862613678,
  -0.3829095661640167, -0.4283657670021057, 0.152811661362648,
  0.318326860666275, -0.1847081780433655, 0.1472633183002472,
  0.3261867761611938, 0.4440855979919434, 0.1532684862613678,
  0.4912451505661011, -0.8813056349754333, 0.1532684862613678,
  0.8421515226364136, 0.5541245341300964, 0.1611284017562866,
  -0.9124839305877686, -0.1532684862613678, 0.1611284017562866,
  -0.7912652492523193, 0.750622570514679, 0.1611284017562866,
  -0.3826613128185272, -0.6484435796737671, 0.1611284017562866,
  -0.3792538344860077, -0.1454085558652878, 0.1611284017562866,
  0.3138867020606995, -0.2947470843791962, 0.1611284017562866,
  0.3346125483512878, -0.6405836343765259, 0.1611284017562866,
  0.7141164541244507, 0.8056420087814331, 0.1611284017562866,
  0.8655781149864197, -0.0196498055011034, 0.1689883321523666,
  -0.8845840692520142, -0.5305447578430176, 0.1689883321523666,
  -0.538404643535614, -0.8831716179847717, 0.1689883321523666,
  -0.3743332326412201, -0.0589494146406651, 0.1689883321523666,
  -0.3700129389762878, 0.5934241414070129, 0.1689883321523666,
  0.3165565133094788, -0.4991050660610199, 0.1689883321523666,
  0.422149270772934, 0.8056420087814331, 0.1689883321523666, 0.8295514583587646,
  -0.6720233559608459, 0.1768482476472855, -0.9089068174362183,
  -0.3104669153690338, 0.1768482476472855, -0.8076569437980652,
  -0.7349027395248413, 0.1768482476472855, -0.3898687958717346,
  -0.7899221777915955, 0.1768482476472855, -0.3680696785449982,
  0.082529179751873, 0.1743764281272888, 0.302606999874115, -0.0353696495294571,
  0.1768482476472855, 0.311797708272934, -0.5069649815559387,
  0.1768482476472855, 0.5541245341300964, -0.9115517735481262,
  0.1768482476472855, 0.8669726848602295, -0.4676653742790222,
  0.1847081780433655, -0.9083100557327271, 0.1454085558652878,
  0.1847081780433655, -0.7584825158119202, -0.8222662210464478,
  0.1847081780433655, -0.366672158241272, -0.6170039176940918,
  0.1847081780433655, -0.3629094958305359, 0.0039299610070884,
  0.1847081780433655, 0.2931810021400452, 0.2711673080921173, 0.178806871175766,
  0.318326860666275, -0.5934241414070129, 0.1782530248165131,
  0.6170039176940918, -0.8842412233352661, 0.1847081780433655,
  0.8685160279273987, -0.3419066071510315, 0.1894385665655136,
  -0.907820999622345, -0.2004280090332031, 0.1925680935382843,
  -0.8921011686325073, -0.5066286325454712, 0.1925680935382843,
  -0.5711857676506042, -0.8763813376426697, 0.1902392357587814,
  -0.3576264679431915, -0.2004280090332031, 0.1925680935382843,
  -0.3506578803062439, 0.3419066071510315, 0.1857964396476746,
  0.2947470843791962, -0.0982490256428719, 0.1925680935382843,
  0.318326860666275, 0.7319768667221069, 0.1925680935382843, 0.7113229632377625,
  -0.8481510877609253, 0.1925680935382843, 0.8695675730705261,
  -0.3654863834381104, 0.2004280090332031, -0.9056701064109802,
  0.2633073925971985, 0.2004280090332031, -0.6327237486839294,
  -0.8570187091827393, 0.2004280090332031, -0.3502944707870483,
  -0.475525289773941, 0.2004280090332031, -0.3468783795833588,
  0.1689883321523666, 0.2004280090332031, 0.2792157828807831,
  0.2082879394292831, 0.2004280090332031, 0.3136737048625946,
  -0.6877431869506836, 0.2004280090332031, 0.6956031322479248,
  0.8157997131347656, 0.2004280090332031, 0.8716222643852234,
  -0.1139688715338707, 0.2082879394292831, -0.8921011686325073,
  0.456536203622818, 0.2082879394292831, -0.5681903958320618,
  -0.8763813376426697, 0.2082879394292831, -0.3467428982257843,
  -0.5541245341300964, 0.2082879394292831, -0.3367542326450348,
  0.3419066071510315, 0.2015008181333542, 0.2790272235870361,
  0.2790272235870361, 0.2032907009124756, 0.3104669153690338,
  -0.6798832416534424, 0.2082879394292831, 0.6956031322479248,
  0.8162888288497925, 0.2082879394292831, 0.8727383613586426,
  -0.1296887099742889, 0.216147854924202, -0.8993663191795349,
  0.4362256824970245, 0.216147854924202, -0.5667120218276978,
  -0.8763813376426697, 0.2093050926923752, -0.3419066071510315,
  -0.1847081780433655, 0.2138107270002365, -0.3340466916561127,
  0.6248638033866882, 0.2099138647317886, 0.2711673080921173,
  0.1296887099742889, 0.2135724276304245, 0.2868871688842773,
  0.6405836343765259, 0.216147854924202, 0.538404643535614, -0.919379711151123,
  0.216147854924202, 0.8685213923454285, -0.5097385048866272, 0.224007785320282,
  -0.9026765823364258, 0.0353696495294571, 0.224007785320282,
  -0.7349027395248413, 0.7866254448890686, 0.2162710279226303,
  -0.3419066071510315, -0.5855641961097717, 0.224007785320282,
  -0.3264579474925995, 0.0982490256428719, 0.2222619205713272,
  0.2633073925971985, -0.1139688715338707, 0.224007785320282,
  0.2639045417308807, -0.302606999874115, 0.224007785320282, 0.381206214427948,
  -0.8402339220046997, 0.224007785320282, 0.8277224898338318,
  -0.7191829085350037, 0.224007785320282, 0.8734048008918762,
  0.4362256824970245, 0.2302132248878479, -0.8135019540786743,
  -0.6877431869506836, 0.2318677008152008, -0.4047859907150269,
  0.7875581979751587, 0.2318677008152008, -0.3219648897647858,
  -0.4519455134868622, 0.2317472845315933, -0.3104669153690338,
  0.4519455134868622, 0.2267904579639435, 0.2554474771022797,
  0.3654863834381104, 0.2318677008152008, 0.2813865542411804,
  -0.6484435796737671, 0.2318677008152008, 0.6484435796737671,
  -0.8749876022338867, 0.2318677008152008, 0.8761787414550781,
  -0.2004280090332031, 0.2397276312112808, -0.9000719785690308,
  0.1139688715338707, 0.2397276312112808, -0.8007663488388062,
  -0.7191829085350037, 0.2397276312112808, -0.3654863834381104,
  -0.8057809472084045, 0.2397276312112808, -0.312992662191391,
  -0.3340466916561127, 0.2397276312112808, -0.3049080371856689,
  0.5777042508125305, 0.2397276312112808, 0.2404397875070572,
  0.3576264679431915, 0.2397276312112808, 0.2789381146430969,
  -0.6798832416534424, 0.2397276312112808, 0.6170039176940918,
  -0.888454794883728, 0.2353120595216751, 0.8763813376426697,
  -0.318326860666275, 0.2438125461339951, -0.8999611139297485,
  -0.0668093413114548, 0.2475875467061996, -0.8482615351676941,
  0.538404643535614, 0.2475875467061996, -0.4613711833953857,
  -0.8685213923454285, 0.2422481328248978, -0.3104669153690338,
  -0.0432295724749565, 0.2475875467061996, -0.2951343953609467,
  0.2868871688842773, 0.244773805141449, 0.2397276312112808, -0.137548640370369,
  0.2475875467061996, 0.2397986203432083, 0.5619844198226929,
  0.2475875467061996, 0.3771987855434418, 0.8135019540786743,
  0.2475875467061996, 0.8229106664657593, -0.7584825158119202,
  0.2475875467061996, 0.8781960010528564, 0.2790272235870361,
  0.2554474771022797, -0.8309096693992615, 0.5777042508125305,
  0.2554474771022797, -0.4362256824970245, -0.8556993007659912,
  0.2485999017953873, -0.302606999874115, 0.0117898834869266,
  0.2513591945171356, -0.2868871688842773, 0.4362256824970245,
  0.2548192739486694, 0.2318677008152008, -0.3419066071510315,
  0.2477303892374039, 0.2397276312112808, -0.3261867761611938,
  0.2554474771022797, 0.3776233494281769, -0.8528015613555908,
  0.2554474771022797, 0.8225670456886292, -0.7663424015045166,
  0.2554474771022797, 0.8790927529335022, 0.3576264679431915,
  0.2591596245765686, -0.8135019540786743, -0.6720233559608459,
  0.2631254494190216, -0.4126459062099457, -0.8449416160583496,
  0.2633073925971985, -0.2917493581771851, -0.5069649815559387,
  0.2572867572307587, -0.2790272235870361, 0.4440855979919434,
  0.2633073925971985, 0.2099374979734421, 0.2397276312112808,
  0.2633073925971985, 0.2200760245323181, 0.5934241414070129,
  0.2633073925971985, 0.302606999874115, -0.8162485957145691,
  0.2633073925971985, 0.7899221777915955, -0.8257573246955872,
  0.2633073925971985, 0.8812405467033386, 0.137548640370369, 0.2711673080921173,
  -0.852648138999939, -0.5619844198226929, 0.2711673080921173,
  -0.4680831432342529, -0.8842412233352661, 0.2711673080921173,
  -0.2844819128513336, -0.5305447578430176, 0.2643532156944275,
  -0.2711673080921173, 0.3497665226459503, 0.26919886469841, 0.2004280090332031,
  0.2790272235870361, 0.2654497623443604, 0.2082879394292831,
  0.4519455134868622, 0.2711673080921173, 0.2240567207336426,
  -0.538404643535614, 0.2711673080921173, 0.4912451505661011,
  -0.9178990721702576, 0.2693366706371307, 0.860661506652832,
  0.5462645888328552, 0.2790272235870361, -0.8940762281417847,
  -0.1532684862613678, 0.2714671492576599, -0.7742023468017578,
  0.7427626252174377, 0.2730532586574554, -0.3104669153690338,
  -0.7663424015045166, 0.2790272235870361, -0.2673243582248688,
  -0.2947470843791962, 0.2790272235870361, -0.2508691549301147,
  0.2475875467061996, 0.2743310332298279, 0.1925680935382843,
  0.2633073925971985, 0.2790272235870361, 0.1993170827627182,
  0.6720233559608459, 0.2725175321102142, 0.2633073925971985,
  -0.7820622324943542, 0.2790272235870361, 0.7113229632377625,
  -0.8546150922775269, 0.2790272235870361, 0.8838812112808228,
  -0.0668093413114548, 0.2868871688842773, -0.8781402707099915,
  -0.4991050660610199, 0.2868871688842773, -0.5462645888328552,
  -0.879498302936554, 0.2790551781654358, -0.2711673080921173,
  -0.475525289773941, 0.2868871688842773, -0.252791553735733,
  -0.0903891026973724, 0.2868871688842773, -0.2338421642780304,
  0.3654863834381104, 0.2859777212142944, 0.1847081780433655,
  -0.2397276312112808, 0.2800748646259308, 0.1925680935382843,
  -0.1768482476472855, 0.2794913649559021, 0.2554474771022797,
  -0.7820622324943542, 0.2868871688842773, 0.7270427942276001,
  -0.8490912914276123, 0.2813284993171692, 0.8842412233352661,
  -0.0196498055011034, 0.2926603555679321, -0.8921011686325073,
  0.0275097284466028, 0.2947470843791962, -0.8449416160583496,
  -0.5712560415267944, 0.2947470843791962, -0.4676653742790222,
  0.8525850772857666, 0.2876007556915283, -0.2554474771022797,
  -0.3576264679431915, 0.2947470843791962, -0.2388689666986465,
  -0.082529179751873, 0.2947470843791962, -0.2195329666137695,
  0.2711673080921173, 0.2930790483951569, 0.1611284017562866,
  0.5698443651199341, 0.2906320691108704, 0.1768482476472855,
  -0.2318677008152008, 0.2947470843791962, 0.2109719216823578,
  -0.6563035249710083, 0.2947470843791962, 0.5426831841468811,
  0.8842412233352661, 0.2947470843791962, 0.8762195110321045,
  -0.5305447578430176, 0.302606999874115, -0.8898520469665527,
  -0.3497665226459503, 0.2958096861839294, -0.7820622324943542,
  -0.7427626252174377, 0.302606999874115, -0.3576264679431915,
  0.7950976490974426, 0.302606999874115, -0.2361559122800827,
  -0.4519455134868622, 0.2978256344795227, -0.216147854924202,
  0.2082879394292831, 0.302606999874115, -0.2010324150323868,
  0.4991050660610199, 0.2974763810634613, 0.1454085558652878,
  0.4598054587841034, 0.2992584705352783, 0.1611284017562866,
  -0.2082879394292831, 0.300792783498764, 0.2004280090332031,
  -0.6484435796737671, 0.302606999874115, 0.4912451505661011,
  0.8890374898910522, 0.299332469701767, 0.8685213923454285, 0.5305447578430176,
  0.3104669153690338, -0.8890944123268127, -0.1532684862613678,
  0.3104669153690338, -0.7584825158119202, -0.8088114857673645,
  0.3104669153690338, -0.2868871688842773, -0.797110915184021,
  0.3104669153690338, -0.2170547991991043, -0.3654863834381104,
  0.3026173114776611, -0.2004280090332031, 0.4205058217048645,
  0.3104669153690338, -0.1871093511581421, 0.6798832416534424,
  0.3056489825248718, 0.1218287944793701, 0.3733462989330292,
  0.3084069490432739, 0.137548640370369, -0.0353696495294571,
  0.3104669153690338, 0.1594770550727844, -0.4912451505661011,
  0.3104669153690338, 0.2947470843791962, -0.8412619829177856,
  0.3104669153690338, 0.7742023468017578, -0.833905041217804,
  0.3104669153690338, 0.8889819383621216, 0.0589494146406651, 0.318326860666275,
  -0.8528015613555908, 0.498477578163147, 0.318326860666275, -0.475525289773941,
  -0.9008826613426208, 0.3166928887367249, -0.224007785320282,
  -0.5462645888328552, 0.3167572915554047, -0.1925680935382843,
  -0.0982490256428719, 0.318326860666275, -0.1775331795215607,
  0.7349027395248413, 0.318326860666275, -0.1540898978710175,
  0.4362256824970245, 0.3157726228237152, 0.0982490256428719,
  0.2318677008152008, 0.3161296844482422, 0.1139688715338707,
  0.0353696495294571, 0.318326860666275, 0.1353228092193604, -0.396926075220108,
  0.318326860666275, 0.2004280090332031, 0.7816005349159241, 0.318326860666275,
  0.6091439723968506, -0.8984870910644531, 0.318326860666275,
  0.8881324529647827, -0.4362256824970245, 0.3261867761611938,
  -0.8864365220069885, 0.1768482476472855, 0.3261867761611938,
  -0.6808851361274719, 0.7977821230888367, 0.3261867761611938,
  -0.2444502264261246, -0.750622570514679, 0.3208605647087097,
  -0.1847081780433655, -0.1689883321523666, 0.3260388970375061,
  -0.1532684862613678, 0.0117898834869266, 0.3260754644870758,
  -0.137548640370369, 0.1296887099742889, 0.3260216116905212,
  -0.1218287944793701, 0.4991050660610199, 0.3235188722610474,
  0.0589494146406651, 0.3419066071510315, 0.3202641308307648,
  0.0746692642569542, 0.5462645888328552, 0.3237612545490265,
  0.0982490256428719, -0.082529179751873, 0.3261867761611938,
  0.1247956901788712, -0.4833852052688599, 0.3261867761611938,
  0.2475875467061996, 0.8023990392684937, 0.3261867761611938,
  0.7191829085350037, -0.8553391098976135, 0.3261867761611938,
  0.8915672302246094, -0.0589494146406651, 0.3340466916561127,
  -0.8685213923454285, 0.4616924822330475, 0.3340466916561127,
  -0.5226848125457764, 0.8455283641815186, 0.3316870033740997,
  -0.2082879394292831, -0.6170039176940918, 0.3267934024333954,
  -0.1611284017562866, -0.082529179751873, 0.3340466916561127,
  -0.1296887099742889, 0.744389533996582, 0.3308585286140442,
  -0.1061089485883713, 0.1689883321523666, 0.3311932384967804,
  -0.0903891026973724, 0.381206214427948, 0.3333086371421814,
  -0.0668093413114548, 0.2475875467061996, 0.3330908417701721,
  -0.0432295724749565, 0.4205058217048645, 0.3337083756923676,
  -0.0117898834869266, 0.2475875467061996, 0.3312563300132751,
  0.0117898834869266, 0.2947470843791962, 0.3300126194953918,
  0.0275097284466028, 0.6484435796737671, 0.3279597461223602,
  0.0510894954204559, 0.2082879394292831, 0.3334176540374756, 0.082529179751873,
  -0.2633073925971985, 0.3277875185012817, 0.1139688715338707,
  -0.4205058217048645, 0.3304545879364014, 0.2711673080921173,
  0.8135019540786743, 0.3340466916561127, 0.750622570514679, 0.8022328019142151,
  0.3294892311096191, 0.8921011686325073, 0.0432295724749565,
  0.3390934765338898, -0.8842412233352661, 0.224007785320282,
  0.3419066071510315, -0.8003636598587036, -0.6641634106636047,
  0.3419066071510315, -0.381206214427948, -0.8655706644058228,
  0.3361198604106903, -0.1768482476472855, 0.7584825158119202,
  0.3353233635425568, -0.1296887099742889, -0.0982490256428719,
  0.3359412848949432, -0.0903891026973724, 0.7270427942276001,
  0.3368052542209625, -0.0510894954204559, 0.137548640370369,
  0.3343265056610107, -0.0196498055011034, 0.2318677008152008,
  0.3419066071510315, 0.0196498055011034, -0.1082724779844284,
  0.3401234447956085, 0.0510894954204559, -0.224007785320282,
  0.3419066071510315, 0.085929162800312, -0.5148249268531799,
  0.3369219601154327, 0.1847081780433655, 0.7899221777915955,
  0.3419066071510315, 0.6289946436882019, -0.8921011686325073,
  0.3419066071510315, 0.8920861482620239, -0.3654863834381104,
  0.3497665226459503, -0.8826856017112732, -0.3261867761611938,
  0.3497665226459503, -0.7663424015045166, -0.7589753866195679,
  0.3497665226459503, -0.318326860666275, -0.8390623331069946,
  0.3497665226459503, -0.1454085558652878, -0.532292366027832,
  0.3435054421424866, -0.0982490256428719, -0.1689883321523666,
  0.3477448225021362, -0.0510894954204559, -0.1768482476472855,
  0.3470375835895538, -0.0039299610070884, -0.1847081780433655,
  0.3443437814712524, 0.0353696495294571, -0.2554474771022797,
  0.3424491882324219, 0.0903891026973724, -0.5462645888328552,
  0.3458656072616577, 0.3104669153690338, 0.8370817303657532,
  0.3497665226459503, 0.8213618397712708, -0.8155651092529297,
  0.3497665226459503, 0.8953438997268677, 0.0510894954204559,
  0.3576264679431915, -0.8401675820350647, -0.5541245341300964,
  0.3576264679431915, -0.4598054587841034, -0.9057453274726868,
  0.3576264679431915, -0.16348797082901, -0.6798832416534424,
  0.3510474264621735, -0.082529179751873, -0.3576264679431915,
  0.3538747131824493, -0.0275097284466028, -0.3654863834381104,
  0.3576264679431915, 0.0275097284466028, -0.5323638916015625,
  0.3553275763988495, 0.1139688715338707, -0.7349027395248413,
  0.3576264679431915, 0.4283657670021057, 0.8847444653511047,
  0.3576264679431915, 0.8577521443367004, 0.6170039176940918,
  0.3654863834381104, -0.8802106380462646, -0.318326860666275,
  0.3654863834381104, -0.7817218899726868, 0.6563035249710083,
  0.3654863834381104, -0.318326860666275, -0.8480034470558167,
  0.3576903939247131, -0.1218287944793701, -0.5541245341300964,
  0.3606182932853699, -0.0275097284466028, -0.4912451505661011,
  0.3634742796421051, 0.0668093413114548, -0.6877431869506836,
  0.3625450134277344, 0.3261867761611938, 0.8528015613555908,
  0.3654863834381104, 0.8311747908592224, -0.7977821230888367,
  0.3654863834381104, 0.8963314294815063, 0.2397276312112808,
  0.3733462989330292, -0.8185831308364868, -0.6012840270996094,
  0.3733462989330292, -0.4211702048778534, 0.860661506652832,
  0.3688256740570068, -0.1218287944793701, -0.6877431869506836,
  0.3665891587734222, -0.0275097284466028, -0.5698443651199341,
  0.366440087556839, 0.0903891026973724, -0.7584825158119202,
  0.3733462989330292, 0.4440855979919434, 0.8959569931030273,
  0.3733462989330292, 0.8699353933334351, -0.6170039176940918,
  0.381206214427948, -0.8776849508285522, -0.1925680935382843,
  0.381206214427948, -0.7636609673500061, 0.7034630179405212, 0.381206214427948,
  -0.2883709073066711, -0.8449416160583496, 0.3755686581134796,
  -0.0589494146406651, -0.6798832416534424, 0.381206214427948,
  0.0903891026973724, -0.8149895071983337, 0.381206214427948,
  0.4991050660610199, 0.8937080502510071, 0.381206214427948, 0.8763813376426697,
  0.549849271774292, 0.381206214427948, 0.9001412391662598, 0.1061089485883713,
  0.3890661597251892, -0.8262384533882141, 0.5305447578430176,
  0.3890661597251892, -0.4205058217048645, 0.8673808574676514,
  0.3890661597251892, -0.0740405097603798, -0.7899221777915955,
  0.3890661597251892, 0.137548640370369, -0.840374767780304, 0.3890661597251892,
  0.5541245341300964, 0.8846676349639893, 0.3825469613075256,
  0.8921011686325073, 0.4833852052688599, 0.3894059062004089,
  -0.8763813376426697, -0.1925680935382843, 0.396926075220108,
  -0.835142195224762, 0.5069649815559387, 0.396926075220108,
  -0.4598054587841034, 0.8656346201896667, 0.3964181542396545,
  -0.0510894954204559, -0.8056420087814331, 0.396926075220108,
  0.2664713561534882, -0.8921011686325073, 0.396926075220108,
  0.7663424015045166, -0.8428312540054321, 0.396926075220108,
  0.9010576605796814, -0.3419066071510315, 0.4047859907150269,
  -0.8735947012901306, 0.302606999874115, 0.4047859907150269,
  -0.5934241414070129, -0.8613795042037964, 0.4047859907150269,
  -0.1341879963874817, -0.8213618397712708, 0.4047859907150269,
  0.2475875467061996, 0.8595933318138123, 0.4047859907150269,
  0.7349027395248413, -0.8550665378570557, 0.4047859907150269,
  0.9044870138168335, -0.1454085558652878, 0.4126459062099457,
  -0.8634998202323914, 0.4440855979919434, 0.4126459062099457, -0.5426065325737,
  -0.8763813376426697, 0.4126459062099457, -0.0668093413114548,
  -0.8242595195770264, 0.4126459062099457, 0.2908842861652374,
  -0.9156809449195862, 0.4126459062099457, 0.8370817303657532,
  -0.7990119457244873, 0.4126459062099457, 0.9037320017814636,
  0.224007785320282, 0.4205058217048645, -0.8062464594841003,
  -0.6091439723968506, 0.4205058217048645, -0.4126459062099457,
  0.8764006495475769, 0.4205058217048645, 0.0039299610070884,
  0.8180995583534241, 0.4205058217048645, 0.4205058217048645,
  0.8812829852104187, 0.4205058217048645, 0.860661506652832,
  -0.6894950866699219, 0.4283657670021057, -0.8701545596122742,
  -0.4362256824970245, 0.4283657670021057, -0.7743526697158813,
  0.6484435796737671, 0.4283657670021057, -0.3286515772342682,
  0.8449416160583496, 0.4283657670021057, 0.0746692642569542,
  0.8357598185539246, 0.4283657670021057, 0.5305447578430176,
  0.8697507381439209, 0.4283657670021057, 0.8921011686325073,
  -0.5537146329879761, 0.4362256824970245, -0.8687970042228699,
  -0.3890661597251892, 0.4362256824970245, -0.8391635417938232,
  -0.5226848125457764, 0.4362256824970245, -0.5148249268531799,
  0.844432532787323, 0.4321385025978088, -0.0432295724749565,
  -0.8449416160583496, 0.4362256824970245, 0.3654863834381104,
  -0.9219335317611694, 0.4362256824970245, 0.8400282263755798,
  0.7584825158119202, 0.4362256824970245, 0.9096107482910156,
  -0.1296887099742889, 0.4440855979919434, -0.8668684363365173,
  0.381206214427948, 0.4440855979919434, -0.5635281801223755, 0.829221785068512,
  0.4440855979919434, -0.0903891026973724, 0.8254776000976563,
  0.4440855979919434, 0.318326860666275, 0.8809042572975159, 0.4440855979919434,
  0.8440074920654297, -0.7820622324943542, 0.4440855979919434,
  0.9108724594116211, -0.0903891026973724, 0.4519455134868622,
  -0.8222762942314148, -0.5541245341300964, 0.4519455134868622,
  -0.4598054587841034, -0.9024708867073059, 0.4519455134868622,
  -0.0196498055011034, 0.8359833955764771, 0.4519455134868622,
  0.4126459062099457, -0.9081866145133972, 0.4519455134868622,
  0.860661506652832, -0.7094166278839111, 0.4519455134868622,
  0.9107736349105835, 0.1768482476472855, 0.4598054587841034,
  -0.8064783811569214, 0.5462645888328552, 0.4598054587841034,
  -0.396926075220108, 0.884146511554718, 0.4598054587841034, 0.0589494146406651,
  0.8549475073814392, 0.4598054587841034, 0.5069649815559387,
  0.8571310043334961, 0.4598054587841034, 0.8987911343574524,
  -0.5462645888328552, 0.4676653742790222, -0.8633748292922974,
  -0.0589494146406651, 0.4676653742790222, -0.7331290245056152,
  -0.8056420087814331, 0.4651135504245758, -0.2082879394292831,
  -0.8763813376426697, 0.4676653742790222, 0.224007785320282,
  -0.9231309294700623, 0.4676653742790222, 0.7301099896430969,
  -0.860661506652832, 0.4676653742790222, 0.9144105911254883,
  -0.1454085558652878, 0.475525289773941, -0.8560273051261902,
  0.4362256824970245, 0.475525289773941, -0.5462645888328552,
  0.8339663147926331, 0.4716406762599945, -0.0510894954204559,
  0.8449416160583496, 0.475525289773941, 0.4126459062099457, -0.898112416267395,
  0.475525289773941, 0.86859530210495, -0.6877431869506836, 0.475525289773941,
  0.9157847762107849, -0.0668093413114548, 0.4833852052688599,
  -0.8474647402763367, -0.4833852052688599, 0.4833852052688599,
  -0.5353105664253235, 0.8370817303657532, 0.4830096960067749,
  -0.0510894954204559, 0.8528015613555908, 0.4833852052688599,
  0.4126459062099457, 0.8549379110336304, 0.4833852052688599,
  0.8661984205245972, -0.7034630179405212, 0.4833852052688599,
  0.9173532724380493, 0.0117898834869266, 0.4912451505661011,
  -0.8590271472930908, 0.4047859907150269, 0.4912451505661011,
  -0.5541245341300964, -0.8708759546279907, 0.484236866235733,
  -0.0432295724749565, -0.8921011686325073, 0.4847525656223297,
  0.4362256824970245, -0.8921011686325073, 0.4912451505661011,
  0.882773756980896, -0.6327237486839294, 0.4991050660610199,
  -0.8583439588546753, -0.4205058217048645, 0.4991050660610199,
  -0.7611778378486633, -0.6877431869506836, 0.4991050660610199,
  -0.2947470843791962, -0.9099017977714539, 0.4979033172130585,
  0.1768482476472855, -0.9156809449195862, 0.4991050660610199,
  0.6956031322479248, -0.8689843416213989, 0.4973296821117401,
  0.9156809449195862, 0.3419066071510315, 0.5069649815559387,
  -0.8573738932609558, 0.1847081780433655, 0.5069649815559387,
  -0.6405836343765259, 0.804783046245575, 0.5069649815559387,
  -0.1296887099742889, -0.9029891490936279, 0.5055562257766724,
  0.3419066071510315, 0.8528015613555908, 0.5069649815559387,
  0.8563900589942932, -0.7584825158119202, 0.5069649815559387,
  0.9207648634910583, 0.1611284017562866, 0.5148249268531799,
  -0.8027247786521912, 0.5305447578430176, 0.5148249268531799,
  -0.4156519770622253, 0.8763813376426697, 0.5148249268531799,
  0.0668093413114548, -0.9228562712669373, 0.5148249268531799,
  0.6012840270996094, -0.8696098923683167, 0.5148249268531799,
  0.9113888740539551, 0.4833852052688599, 0.5226848125457764,
  -0.8547379970550537, 0.1296887099742889, 0.5226848125457764,
  -0.6798832416534424, 0.792646586894989, 0.5226848125457764,
  -0.1611284017562866, -0.9126427173614502, 0.5226848125457764,
  0.318326860666275, 0.8487836718559265, 0.5226848125457764, 0.8454988598823547,
  -0.8135019540786743, 0.5226848125457764, 0.9224564433097839,
  0.1925680935382843, 0.5305447578430176, -0.8527507185935974,
  -0.0117898834869266, 0.5305447578430176, -0.5698443651199341,
  -0.8652971386909485, 0.525008499622345, -0.0668093413114548,
  0.8842412233352661, 0.5305447578430176, 0.4519455134868622,
  -0.8738110661506653, 0.5305447578430176, 0.8871882557868958,
  -0.6327237486839294, 0.5335580706596375, -0.8528015613555908,
  -0.3576264679431915, 0.538404643535614, -0.829221785068512,
  0.4664962589740753, 0.538404643535614, -0.4991050660610199,
  -0.8861898183822632, 0.5365393757820129, 0.0432295724749565,
  0.8763813376426697, 0.538404643535614, 0.5619844198226929,
  -0.8632525205612183, 0.538404643535614, 0.9052742123603821,
  0.5226848125457764, 0.5462645888328552, -0.8493046760559082,
  -0.0589494146406651, 0.5462645888328552, -0.7191829085350037,
  0.7730412483215332, 0.5393452048301697, -0.1689883321523666,
  -0.9235408306121826, 0.5428546667098999, 0.3654863834381104,
  0.8370817303657532, 0.5462645888328552, 0.8640516400337219,
  0.7113229632377625, 0.5462645888328552, 0.9223300218582153,
  0.1925680935382843, 0.5541245341300964, -0.8054912686347961,
  0.5069649815559387, 0.5541245341300964, -0.4283657670021057,
  -0.9119547009468079, 0.5509842038154602, 0.1218287944793701,
  -0.8999611139297485, 0.5541245341300964, 0.6641634106636047,
  0.8131040334701538, 0.5541245341300964, 0.9203916788101196,
  -0.3261867761611938, 0.5605167150497437, -0.8449416160583496,
  0.2711673080921173, 0.5619844198226929, -0.7610123157501221,
  0.6170039176940918, 0.5619844198226929, -0.318326860666275,
  0.8977097272872925, 0.5619844198226929, 0.1925680935382843,
  -0.887339174747467, 0.5590572357177734, 0.7427626252174377,
  -0.8449416160583496, 0.5619844198226929, 0.9100905060768127,
  0.475525289773941, 0.5698443651199341, -0.8413273096084595, 0.224007785320282,
  0.5698443651199341, -0.6062408685684204, 0.8135019540786743,
  0.5639050602912903, -0.0432295724749565, 0.8763813376426697,
  0.5628345012664795, 0.4833852052688599, 0.8213618397712708,
  0.5698443651199341, 0.8955191373825073, -0.6012840270996094,
  0.5698443651199341, 0.9119362831115723, 0.0353696495294571,
  0.5777042508125305, -0.83098304271698, 0.4440855979919434, 0.5777042508125305,
  -0.5305447578430176, 0.8374974131584167, 0.5777042508125305,
  0.0117898834869266, 0.8632611632347107, 0.5777042508125305,
  0.5462645888328552, 0.8120381832122803, 0.5777042508125305,
  0.8996021151542664, 0.3104669153690338, 0.5741048455238342, 0.907820999622345,
  0.0039299610070884, 0.5855641961097717, -0.836688220500946,
  -0.3733462989330292, 0.5847030878067017, -0.7270427942276001,
  -0.7427626252174377, 0.5853824019432068, -0.224007785320282,
  0.8921011686325073, 0.5855641961097717, 0.2959697842597961,
  -0.8685213923454285, 0.5855641961097717, 0.8340075016021729,
  -0.829221785068512, 0.5855641961097717, 0.8940876126289368,
  -0.5541245341300964, 0.5934241414070129, -0.8321236371994019,
  -0.4598054587841034, 0.5934241414070129, -0.750622570514679,
  0.6299059391021729, 0.5934241414070129, -0.2711673080921173,
  -0.939681351184845, 0.5934241414070129, 0.2475875467061996,
  0.8310248851776123, 0.5934241414070129, 0.7977821230888367,
  -0.8322442173957825, 0.5934241414070129, 0.8805663585662842,
  -0.0589494146406651, 0.5882942080497742, 0.8921011686325073,
  -0.4205058217048645, 0.6012840270996094, -0.8258125185966492,
  -0.475525289773941, 0.6012840270996094, -0.7270427942276001,
  0.6982570886611938, 0.6012840270996094, -0.2318677008152008,
  0.8875399827957153, 0.6012840270996094, 0.2868871688842773,
  0.8244041800498962, 0.6012840270996094, 0.829221785068512, 0.7890488505363464,
  0.6006203293800354, 0.8763813376426697, -0.4440855979919434, 0.59475177526474,
  0.8763813376426697, 0.381206214427948, 0.6091439723968506,
  -0.8209388256072998, -0.4833852052688599, 0.6091439723968506,
  -0.4991050660610199, 0.8481133580207825, 0.6046167612075806,
  0.0117898834869266, -0.8921011686325073, 0.6091439723968506,
  0.5462645888328552, 0.8009556531906128, 0.6091439723968506,
  0.8593887686729431, -0.1454085558652878, 0.604391872882843, 0.860661506652832,
  0.6563035249710083, 0.6170039176940918, -0.8249725699424744,
  -0.4205058217048645, 0.6170039176940918, -0.8208469748497009,
  0.4205058217048645, 0.6170039176940918, -0.5069649815559387,
  -0.8827873468399048, 0.6170039176940918, 0.0039299610070884,
  -0.8881557583808899, 0.6158822774887085, 0.5541245341300964,
  0.7977821230888367, 0.615969717502594, 0.8449416160583496, 0.6720233559608459,
  0.6170039176940918, 0.851208508014679, 0.224007785320282, 0.6243910193443298,
  -0.8213618397712708, -0.3890661597251892, 0.6248638033866882,
  -0.7427626252174377, -0.6733967065811157, 0.6248638033866882,
  -0.3174897730350494, -0.9314007759094238, 0.6172252893447876,
  0.1847081780433655, 0.829221785068512, 0.6248638033866882, 0.7349027395248413,
  0.779442310333252, 0.6248638033866882, 0.8365590572357178,
  -0.0353696495294571, 0.6248638033866882, 0.8393920063972473,
  -0.2318677008152008, 0.6327237486839294, -0.8167114853858948,
  -0.475525289773941, 0.6327237486839294, -0.7529926896095276,
  0.6012840270996094, 0.6327237486839294, -0.3419066071510315,
  0.8879965543746948, 0.6327237486839294, 0.1532684862613678,
  0.8267685770988464, 0.6325002908706665, 0.7113229632377625,
  -0.8213618397712708, 0.6321040391921997, 0.8135019540786743,
  0.5462645888328552, 0.6327237486839294, 0.8229230046272278,
  -0.2947470843791962, 0.6252446174621582, 0.829221785068512,
  0.5619844198226929, 0.6347015500068665, -0.8135019540786743,
  0.318326860666275, 0.6373826265335083, -0.7270427942276001,
  -0.7113229632377625, 0.6405836343765259, -0.2711673080921173,
  0.8744035363197327, 0.6405836343765259, 0.2554474771022797,
  0.8138259053230286, 0.6389667391777039, 0.750622570514679, 0.7663424015045166,
  0.6393555402755737, 0.7899221777915955, 0.5619844198226929,
  0.6405836343765259, 0.8015936613082886, -0.1925680935382843,
  0.6364891529083252, 0.8135019540786743, -0.4912451505661011,
  0.6328207850456238, 0.8213618397712708, -0.0117898834869266,
  0.6484435796737671, -0.8039746284484863, -0.4991050660610199,
  0.6484435796737671, -0.4676653742790222, -0.8979368805885315,
  0.6423187255859375, 0.0275097284466028, 0.8370817303657532,
  0.6484435796737671, 0.5855641961097717, 0.7824865579605103,
  0.6484435796737671, 0.750622570514679, 0.6014718413352966, 0.6439396142959595,
  0.7820622324943542, -0.5855641961097717, 0.6484435796737671,
  0.7801700830459595, 0.2318677008152008, 0.6439329981803894,
  0.7899221777915955, 0.4126459062099457, 0.6525072455406189,
  -0.8056420087814331, -0.0589494146406651, 0.6563035249710083,
  -0.7663424015045166, 0.5486632585525513, 0.6563035249710083,
  -0.3733462989330292, 0.8800890445709229, 0.6563035249710083,
  0.137548640370369, -0.8591330647468567, 0.6563035249710083,
  0.6720233559608459, -0.8095645308494568, 0.6563035249710083,
  0.7207565307617188, 0.6012840270996094, 0.6558284759521484, 0.750622570514679,
  -0.2790272235870361, 0.6563035249710083, 0.7520884871482849,
  0.0903891026973724, 0.6525445580482483, 0.7663424015045166,
  0.2633073925971985, 0.6641634106636047, -0.8028827905654907,
  -0.3340466916561127, 0.6641634106636047, -0.716668963432312,
  0.6956031322479248, 0.6641634106636047, -0.224007785320282,
  -0.8993679881095886, 0.6641634106636047, 0.302606999874115,
  0.8008889555931091, 0.6615940928459167, 0.6798832416534424,
  -0.750622570514679, 0.6641634106636047, 0.7100539207458496,
  -0.5541245341300964, 0.6622328758239746, 0.7270427942276001,
  -0.2790272235870361, 0.6587101817131042, 0.7349027395248413,
  -0.5226848125457764, 0.6590588688850403, 0.7427626252174377,
  -0.0117898834869266, 0.671464204788208, -0.7977821230888367,
  0.0039299610070884, 0.6720233559608459, -0.7055811882019043,
  0.7427626252174377, 0.6720233559608459, -0.2004280090332031,
  0.8517070412635803, 0.6720233559608459, 0.3261867761611938,
  -0.8355162739753723, 0.6702171564102173, 0.6484435796737671,
  0.6877431869506836, 0.6664356589317322, 0.6798832416534424,
  0.6091439723968506, 0.6720233559608459, 0.6956031322479248,
  0.0858380123972893, 0.6699736714363098, 0.7034630179405212,
  0.0589494146406651, 0.6643428206443787, 0.7191829085350037,
  -0.2633073925971985, 0.6798832416534424, -0.7950295209884644,
  -0.2318677008152008, 0.6798832416534424, -0.701711893081665,
  -0.7820622324943542, 0.6798832416534424, -0.1847081780433655,
  0.8468418717384338, 0.6798832416534424, 0.3497665226459503,
  -0.8308869600296021, 0.6762521862983704, 0.6248638033866882,
  -0.7270427942276001, 0.6798832416534424, 0.654872715473175,
  -0.5305447578430176, 0.6756604313850403, 0.6720233559608459,
  -0.5226848125457764, 0.6722258925437927, 0.6798832416534424,
  -0.5541245341300964, 0.6744720339775085, 0.6877431869506836,
  0.0196498055011034, 0.6877431869506836, -0.7930770516395569,
  0.4047859907150269, 0.6877431869506836, -0.5146437883377075,
  0.8449416160583496, 0.6877431869506836, 0.0196498055011034,
  0.8206605911254883, 0.6875379681587219, 0.5541245341300964,
  -0.8056420087814331, 0.6877431869506836, 0.6091439723968506,
  0.5604839324951172, 0.6821570992469788, 0.6327237486839294,
  0.5462645888328552, 0.6826246976852417, 0.6484435796737671,
  -0.4991050660610199, 0.6822324991226196, 0.6563035249710083,
  -0.2082879394292831, 0.6915537118911743, -0.7899221777915955,
  -0.082529179751873, 0.6956031322479248, -0.7646020650863647,
  0.5305447578430176, 0.6956031322479248, -0.381206214427948,
  0.8610246181488037, 0.6932232975959778, 0.137548640370369, 0.8056420087814331,
  0.6935088634490967, 0.5462645888328552, 0.7349027395248413,
  0.6931376457214355, 0.5855641961097717, 0.5777042508125305,
  0.6945925354957581, 0.6091439723968506, 0.3497665226459503,
  0.6944019794464111, 0.6170039176940918, 0.2004280090332031,
  0.6892441511154175, 0.6327237486839294, -0.2633073925971985,
  0.7034630179405212, -0.7850949764251709, -0.0117898834869266,
  0.7034630179405212, -0.6405836343765259, -0.8369677662849426,
  0.7034630179405212, -0.1139688715338707, 0.8294507265090942,
  0.7034630179405212, 0.4205058217048645, 0.775888204574585, 0.6957902312278748,
  0.538404643535614, 0.7270427942276001, 0.7010707259178162, 0.5777042508125305,
  -0.5148249268531799, 0.6973989605903625, 0.5855641961097717,
  0.4833852052688599, 0.6969730854034424, 0.6012840270996094,
  -0.381206214427948, 0.7113229632377625, -0.7853361964225769,
  -0.4047859907150269, 0.7113229632377625, -0.7275255918502808,
  -0.6720233559608459, 0.7113229632377625, -0.2947470843791962,
  -0.8891515731811523, 0.7113229632377625, 0.2318677008152008,
  0.7911261916160583, 0.7113229632377625, 0.4958352148532867,
  -0.6877431869506836, 0.7113229632377625, 0.5354923605918884,
  -0.538404643535614, 0.7037652730941772, 0.5619844198226929,
  -0.5462645888328552, 0.7063125371932983, 0.5619844198226929,
  0.4126459062099457, 0.7056952118873596, 0.5777042508125305,
  0.1611284017562866, 0.7191829085350037, -0.7793242335319519,
  -0.2633073925971985, 0.7184997200965881, -0.6877431869506836,
  -0.8135019540786743, 0.7191829085350037, -0.2004280090332031,
  0.8323783278465271, 0.7191829085350037, 0.3340466916561127,
  -0.8185803890228271, 0.7163452506065369, 0.475525289773941,
  0.6563035249710083, 0.7191829085350037, 0.5123786330223083,
  0.4440855979919434, 0.7191829085350037, 0.5293726325035095,
  0.1454085558652878, 0.7162548303604126, 0.538404643535614, 0.2318677008152008,
  0.7120375037193298, 0.5541245341300964, 0.1925680935382843,
  0.7270427942276001, -0.7397551536560059, 0.5855641961097717,
  0.7270427942276001, -0.3340466916561127, 0.8421208262443542,
  0.7270427942276001, 0.1925680935382843, -0.8282625675201416,
  0.7270427942276001, 0.4362256824970245, 0.6458770036697388,
  0.7237389087677002, 0.475525289773941, 0.5462645888328552, 0.7270427942276001,
  0.4963689148426056, 0.302606999874115, 0.7248857021331787, 0.5069649815559387,
  0.2475875467061996, 0.7214249968528748, 0.5226848125457764,
  0.0668093413114548, 0.7349027395248413, -0.7670073509216309,
  -0.538404643535614, 0.7336606979370117, -0.6877431869506836,
  -0.8056420087814331, 0.7349027395248413, -0.2004280090332031,
  0.8257439732551575, 0.7310128211975098, 0.3340466916561127,
  0.7742023468017578, 0.7327188849449158, 0.4205058217048645,
  -0.6484435796737671, 0.7349027395248413, 0.4578428566455841,
  -0.4676653742790222, 0.7349027395248413, 0.4735648632049561,
  -0.1532684862613678, 0.7323800325393677, 0.4833852052688599,
  0.1218287944793701, 0.7275039553642273, 0.4991050660610199,
  0.2004280090332031, 0.7427626252174377, -0.7273923754692078,
  -0.6563035249710083, 0.7427626252174377, -0.318326860666275,
  -0.8775156736373901, 0.7427626252174377, 0.2082879394292831,
  0.7824977040290833, 0.7402781248092651, 0.381206214427948,
  -0.6720233559608459, 0.7386178970336914, 0.4205058217048645,
  0.538404643535614, 0.7425642609596252, 0.4440855979919434,
  -0.1768482476472855, 0.7427626252174377, 0.4441279470920563,
  0.1847081780433655, 0.7366658449172974, 0.4676653742790222, 0.137548640370369,
  0.750622570514679, -0.7552489042282104, 0.5226848125457764,
  0.7430598139762878, -0.3890661597251892, -0.8842412233352661,
  0.750622570514679, 0.1218287944793701, -0.8272107243537903, 0.750622570514679,
  0.3352693021297455, 0.6720233559608459, 0.7504671216011047,
  0.3890661597251892, -0.5148249268531799, 0.750622570514679,
  0.4115261137485504, 0.2554474771022797, 0.7484094500541687,
  0.4205058217048645, 0.2397276312112808, 0.7456707954406738,
  0.4362256824970245, 0.0668093413114548, 0.7533631324768066,
  -0.7663424015045166, 0.4126459062099457, 0.7584825158119202,
  -0.6964774131774902, -0.750622570514679, 0.7584825158119202,
  -0.2318677008152008, 0.8188443779945374, 0.7531198263168335,
  0.2790272235870361, -0.8056420087814331, 0.7525426745414734,
  0.3340466916561127, -0.6641634106636047, 0.7584825158119202,
  0.3725399971008301, -0.4362256824970245, 0.7578595876693726,
  0.3890661597251892, -0.1218287944793701, 0.7560713887214661,
  0.396926075220108, 0.0903891026973724, 0.7510643005371094, 0.4126459062099457,
  0.2004280090332031, 0.7663424015045166, -0.7256689071655273,
  -0.6484435796737671, 0.7663424015045166, -0.302606999874115,
  0.8223165273666382, 0.7619042992591858, 0.2082879394292831,
  0.7742023468017578, 0.7663424015045166, 0.2922330498695374,
  -0.6327237486839294, 0.7605581879615784, 0.3419066071510315,
  -0.5462645888328552, 0.7660232782363892, 0.3576264679431915,
  -0.1611284017562866, 0.7634979486465454, 0.3654863834381104,
  0.2082879394292831, 0.7593340277671814, 0.381206214427948, 0.2004280090332031,
  0.7742023468017578, -0.7577012181282043, 0.0668093413114548,
  0.7742023468017578, -0.5305447578430176, 0.8388468623161316,
  0.7729529738426208, 0.0039299610070884, 0.7899221777915955,
  0.7698044180870056, 0.2475875467061996, -0.7191829085350037,
  0.7741764187812805, 0.2947470843791962, -0.5305447578430176,
  0.771403968334198, 0.3261867761611938, -0.396926075220108, 0.7731644511222839,
  0.3340466916561127, 0.0589494146406651, 0.7683462500572205,
  0.3497665226459503, -0.137548640370369, 0.7820622324943542,
  -0.7549079656600952, 0.0982490256428719, 0.7820622324943542,
  -0.5462645888328552, 0.8349507451057434, 0.7799558639526367,
  -0.0275097284466028, 0.7899221777915955, 0.7756726145744324,
  0.216147854924202, -0.7427626252174377, 0.7820622324943542,
  0.2598249018192291, 0.5069649815559387, 0.7811789512634277,
  0.2947470843791962, -0.302606999874115, 0.7811536192893982, 0.302606999874115,
  0.1532684862613678, 0.7774146199226379, 0.318326860666275,
  -0.0432295724749565, 0.7899221777915955, -0.7520231604576111,
  0.1139688715338707, 0.7899221777915955, -0.5462645888328552,
  -0.8734665513038635, 0.7899221777915955, -0.0196498055011034,
  -0.8264978528022766, 0.788292407989502, 0.1847081780433655,
  0.6641634106636047, 0.785443902015686, 0.2397276312112808,
  -0.5777042508125305, 0.7886884212493896, 0.2633073925971985,
  0.3497665226459503, 0.7823398113250732, 0.2790272235870361,
  -0.4519455134868622, 0.7842444181442261, 0.2868871688842773,
  0.2318677008152008, 0.7949801087379456, -0.750622570514679,
  0.3890661597251892, 0.7977821230888367, -0.6929762363433838,
  -0.7427626252174377, 0.7971952557563782, -0.224007785320282,
  -0.8449416160583496, 0.7924602031707764, 0.137548640370369,
  -0.7742023468017578, 0.7934125661849976, 0.1925680935382843,
  -0.6248638033866882, 0.7939929366111755, 0.2318677008152008,
  -0.475525289773941, 0.7952263355255127, 0.2397276312112808,
  0.3340466916561127, 0.7936579585075378, 0.2554474771022797,
  -0.1061089485883713, 0.8056420087814331, -0.7466874122619629,
  -0.2790272235870361, 0.7988291382789612, -0.6641634106636047,
  0.7899221777915955, 0.8056420087814331, -0.137548640370369,
  0.7907740473747253, 0.8051370978355408, 0.1139688715338707,
  0.6641634106636047, 0.8056420087814331, 0.1644987612962723,
  -0.5698443651199341, 0.8032228350639343, 0.2004280090332031,
  0.4047859907150269, 0.8041402101516724, 0.216147854924202, -0.082529179751873,
  0.7984732985496521, 0.224007785320282, 0.3654863834381104, 0.8135019540786743,
  -0.7431331872940063, 0.0432295724749565, 0.8135019540786743,
  -0.5619844198226929, 0.8263683319091797, 0.8135019540786743,
  -0.0432295724749565, 0.7785637974739075, 0.8126343488693237,
  0.0982490256428719, -0.6720233559608459, 0.8078715801239014,
  0.1454085558652878, 0.538404643535614, 0.8130423426628113, 0.1768482476472855,
  -0.2554474771022797, 0.8119378089904785, 0.1847081780433655,
  0.1689883321523666, 0.80854332447052, 0.2004280090332031, 0.0903891026973724,
  0.8165889978408813, -0.7427626252174377, 0.396926075220108,
  0.8213618397712708, -0.6929577589035034, 0.6877431869506836,
  0.8213618397712708, -0.216147854924202, 0.7923997640609741,
  0.8146618008613586, 0.0510894954204559, -0.750622570514679,
  0.8153658509254456, 0.0982490256428719, 0.5855641961097717,
  0.8213618397712708, 0.1355645954608917, 0.3576264679431915,
  0.8213618397712708, 0.1474656462669373, -0.082529179751873, 0.816601037979126,
  0.1611284017562866, 0.302606999874115, 0.829221785068512, -0.7389329075813293,
  -0.3576264679431915, 0.829221785068512, -0.6781997680664063,
  -0.7899221777915955, 0.8220731616020203, -0.1611284017562866,
  -0.829221785068512, 0.8222092986106873, 0.0196498055011034,
  0.7191829085350037, 0.829221785068512, 0.0746692642569542,
  -0.5437585115432739, 0.8214530348777771, 0.1139688715338707,
  -0.5226848125457764, 0.829221785068512, 0.1156036779284477,
  -0.0510894954204559, 0.8217462301254272, 0.137548640370369,
  -0.3419066071510315, 0.8368563652038574, -0.7349027395248413,
  -0.1532684862613678, 0.8358851671218872, -0.6798832416534424,
  0.7427626252174377, 0.8370817303657532, -0.1768482476472855,
  -0.8251596689224243, 0.8299713730812073, -0.0117898834869266,
  0.7113229632377625, 0.8344377875328064, 0.0432295724749565,
  -0.5698443651199341, 0.8370817303657532, 0.0690367296338081,
  0.3576264679431915, 0.8304665684700012, 0.0903891026973724,
  -0.4519455134868622, 0.833266019821167, 0.0982490256428719, 0.137548640370369,
  0.8375519514083862, -0.7349027395248413, -0.2711673080921173,
  0.8449416160583496, -0.7294811606407166, 0.5226848125457764,
  0.8449416160583496, -0.3733462989330292, -0.8380774259567261,
  0.8449416160583496, -0.0662776157259941, -0.7349027395248413,
  0.8401513695716858, -0.0117898834869266, 0.5855641961097717,
  0.8379732966423035, 0.0353696495294571, -0.538404643535614,
  0.8437960147857666, 0.0510894954204559, -0.1139688715338707,
  0.8420535326004028, 0.0589494146406651, 0.1532684862613678,
  0.8382811546325684, 0.0746692642569542, 0.1768482476472855,
  0.8528015613555908, -0.7253720760345459, 0.5305447578430176,
  0.8528015613555908, -0.3733462989330292, 0.7942711710929871,
  0.8528015613555908, -0.0943190678954124, 0.6720233559608459,
  0.8468953371047974, -0.0432295724749565, 0.5934241414070129,
  0.8483986854553223, -0.0039299610070884, 0.4519455134868622,
  0.8526237010955811, 0.0117898834869266, 0.1061089485883713, 0.847807765007019,
  0.0275097284466028, -0.3576264679431915, 0.8452104330062866,
  0.0432295724749565, -0.2318677008152008, 0.8598656058311462,
  -0.7270427942276001, 0.4519455134868622, 0.8551833033561707,
  -0.5777042508125305, 0.8135019540786743, 0.860661506652832,
  -0.1456686407327652, -0.7584825158119202, 0.8606213927268982,
  -0.0903891026973724, 0.5541245341300964, 0.860661506652832,
  -0.0510894954204559, 0.4277046918869019, 0.8537065982818604,
  -0.0275097284466028, 0.4519455134868622, 0.8564006090164185,
  -0.0117898834869266, -0.3576264679431915, 0.8528785705566406,
  0.0039299610070884, -0.3654863834381104, 0.8685213923454285,
  -0.7240764498710632, -0.2397276312112808, 0.8685213923454285,
  -0.6460762619972229, 0.7977821230888367, 0.8679916858673096,
  -0.1847081780433655, 0.7427626252174377, 0.8685213923454285,
  -0.1349995881319046, 0.5934241414070129, 0.8651884794235229,
  -0.0903891026973724, 0.4912451505661011, 0.867031455039978,
  -0.0589494146406651, -0.302606999874115, 0.8654646873474121,
  -0.0510894954204559, -0.2711673080921173, 0.8614494204521179,
  -0.0353696495294571, -0.3576264679431915, 0.8763813376426697,
  -0.7218806743621826, -0.318326860666275, 0.8763813376426697,
  -0.6563035249710083, -0.8295323252677917, 0.8763813376426697,
  -0.2206395864486694, -0.7663424015045166, 0.8722111582756042,
  -0.1611284017562866, -0.6641634106636047, 0.8719518184661865,
  -0.1218287944793701, -0.538404643535614, 0.8763813376426697,
  -0.1016247794032097, -0.2318677008152008, 0.8744010925292969,
  -0.0903891026973724, -0.1768482476472855, 0.8699416518211365,
  -0.0746692642569542, -0.3340466916561127, 0.8841570615768433,
  -0.7191829085350037, -0.3340466916561127, 0.8842412233352661,
  -0.7061057090759277, -0.6248638033866882, 0.8842412233352661,
  -0.3576264679431915, -0.8197388648986816, 0.8810893893241882,
  -0.216147854924202, -0.6956031322479248, 0.8821504712104797,
  -0.1768482476472855, 0.5305447578430176, 0.8842412233352661,
  -0.1519461572170258, 0.396926075220108, 0.883185863494873, -0.137548640370369,
  0.302606999874115, 0.8805232048034668, -0.1218287944793701,
  -0.0746692642569542, 0.8774449825286865, -0.1061089485883713,
  -0.0903891026973724, 0.8921011686325073, -0.7166479825973511,
  0.0196498055011034, 0.8921011686325073, -0.5462645888328552,
  0.7958236932754517, 0.8885400295257568, -0.2711673080921173,
  0.7191829085350037, 0.8909669518470764, -0.224007785320282,
  0.5619844198226929, 0.887869119644165, -0.1847081780433655,
  -0.4912451505661011, 0.8921011686325073, -0.1810213178396225,
  0.1061089485883713, 0.886967658996582, -0.1689883321523666,
  0.4205058217048645, 0.8867781758308411, -0.1532684862613678,
  0.1847081780433655, 0.8999611139297485, -0.714515209197998, 0.082529179751873,
  0.8999611139297485, -0.5462645888328552, -0.8328783512115479,
  0.8988282084465027, -0.302606999874115, -0.7034630179405212,
  0.8921950459480286, -0.2554474771022797, -0.6563035249710083,
  0.8962216973304749, -0.224007785320282, -0.475525289773941,
  0.8999611139297485, -0.2225561738014221, 0.0746692642569542,
  0.8968410491943359, -0.2082879394292831, 0.3576264679431915,
  0.8942696452140808, -0.1925680935382843, 0.1139688715338707,
  0.907820999622345, -0.711388111114502, -0.0039299610070884, 0.907820999622345,
  -0.6831350922584534, 0.6641634106636047, 0.907820999622345,
  -0.3576264679431915, -0.7379821538925171, 0.9072274565696716,
  -0.3104669153690338, -0.6012840270996094, 0.9048159718513489,
  -0.2790272235870361, 0.5148249268531799, 0.907820999622345,
  -0.2665528357028961, 0.0039299610070884, 0.9058616757392883,
  -0.2554474771022797, 0.1061089485883713, 0.9026312828063965,
  -0.2397276312112808, -0.2868871688842773, 0.8999789357185364,
  -0.224007785320282, -0.2554474771022797, 0.9156809449195862,
  -0.7085272669792175, -0.1218287944793701, 0.9156809449195862,
  -0.5867463946342468, 0.7899221777915955, 0.9156809449195862,
  -0.37567138671875, -0.6798832416534424, 0.9156809449195862,
  -0.3392749726772308, -0.538404643535614, 0.9156809449195862,
  -0.3156487941741943, -0.3654863834381104, 0.9124428629875183,
  -0.302606999874115, -0.4283657670021057, 0.9127820134162903,
  -0.2947470843791962, -0.0589494146406651, 0.9084790945053101,
  -0.2790272235870361, -0.4126459062099457, 0.9081971049308777,
  -0.2711673080921173, 0.3576264679431915, 0.9235408306121826,
  -0.6834781169891357, -0.6798832416534424, 0.9235408306121826,
  -0.4322670102119446, 0.7113229632377625, 0.9226438999176025,
  -0.3890661597251892, 0.5698443651199341, 0.9164842367172241,
  -0.3654863834381104, 0.6012840270996094, 0.9226331114768982,
  -0.3497665226459503, -0.1689883321523666, 0.9211852550506592,
  -0.3419066071510315, -0.1061089485883713, 0.9178239107131958,
  -0.3340466916561127, 0.4126459062099457, 0.9167938828468323,
  -0.318326860666275, 0.1689883321523666, 0.9314007759094238,
  -0.700549840927124, -0.3733462989330292, 0.9314007759094238,
  -0.6680060625076294, 0.7034630179405212, 0.9261467456817627,
  -0.4519455134868622, 0.750622570514679, 0.9261060953140259,
  -0.4126459062099457, -0.6405836343765259, 0.9314007759094238,
  -0.4005972743034363, -0.318326860666275, 0.9244650602340698,
  -0.396926075220108, 0.5619844198226929, 0.9283508658409119,
  -0.381206214427948, -0.1296887099742889, 0.9242574572563171,
  -0.3733462989330292, 0.4362256824970245, 0.9365465044975281,
  -0.6956031322479248, -0.396926075220108, 0.939260721206665,
  -0.6936638355255127, 0.0196498055011034, 0.939260721206665,
  -0.6535247564315796, -0.7899221777915955, 0.9389768242835999,
  -0.475525289773941, -0.6641634106636047, 0.9348856806755066,
  -0.4519455134868622, 0.5855641961097717, 0.9376978278160095,
  -0.4362256824970245, -0.3576264679431915, 0.9342573285102844,
  -0.4283657670021057, -0.4991050660610199, 0.9353682994842529,
  -0.4205058217048645, -0.0275097284466028, 0.9322268962860107,
  -0.4047859907150269, -0.2790272235870361, 0.9404525756835938,
  -0.6877431869506836, 0.396926075220108, 0.9471206068992615,
  -0.6728366613388062, -0.3890661597251892, 0.9460868239402771,
  -0.6641634106636047, 0.5698443651199341, 0.9471206068992615,
  -0.6012840270996094, 0.7671144008636475, 0.9459198713302612,
  -0.5069649815559387, 0.5934241414070129, 0.9471206068992615,
  -0.4904144704341888, -0.4991050660610199, 0.9462693333625793,
  -0.4833852052688599, 0.2868871688842773, 0.9445978403091431,
  -0.475525289773941, 0.4047859907150269, 0.9419070482254028,
  -0.4598054587841034, -0.3890661597251892, 0.9411203861236572,
  -0.4519455134868622, 0.1689883321523666, 0.9472178816795349,
  -0.6720233559608459, 0.3419066071510315, 0.9517638087272644,
  -0.6563035249710083, -0.2397276312112808, 0.9527527689933777,
  -0.6484435796737671, 0.0117898834869266, 0.9546472430229187,
  -0.6405836343765259, 0.1532684862613678, 0.9549805521965027,
  -0.6340597867965698, 0.4126459062099457, 0.9549805521965027,
  -0.6024473309516907, -0.7191829085350037, 0.9541754126548767,
  -0.5541245341300964, 0.6563035249710083, 0.9549805521965027,
  -0.5418683886528015, -0.318326860666275, 0.9540402889251709,
  -0.538404643535614, 0.4676653742790222, 0.952243447303772,
  -0.5305447578430176, 0.4991050660610199, 0.948160707950592,
  -0.5226848125457764, 0.6327237486839294, 0.9501602053642273,
  -0.5069649815559387, -0.3733462989330292, 0.9489277601242065,
  -0.4991050660610199, 0.0510894954204559, 0.955372154712677,
  -0.6327237486839294, -0.5934241414070129, 0.9564909934997559,
  -0.6248638033866882, -0.1218287944793701, 0.9568860530853271,
  -0.6170039176940918, 0.224007785320282, 0.9571064710617065,
  -0.6091439723968506, 0.4912451505661011, 0.9566255211830139,
  -0.5934241414070129, -0.6798832416534424, 0.9573198556900024,
  -0.5855641961097717, -0.5305447578430176, 0.9573988914489746,
  -0.5777042508125305, -0.4047859907150269, 0.9571967720985413,
  -0.5698443651199341, -0.2711673080921173, 0.9568685293197632,
  -0.5619844198226929, -0.0903891026973724, 0.9561886191368103,
  -0.5541245341300964, 0.1768482476472855,
];
